var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/components/ConnectButton/index.tsx
import { tronAddressFromHex as tronAddressFromHex3 } from "@particle-network/auth-core";
import React11, { useEffect as useEffect9, useState as useState9 } from "react";

// src/provider/ModalChainContext.tsx
import { chains as chainUtils } from "@particle-network/chains";
import { ParticleChains, isEVMProvider, isSolanaProvider } from "@particle-network/connectors";
import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
var ParticleKitChainContext = createContext({
  chains: [],
  isEvm: false,
  isSolana: false,
  renderChains: [],
  isSwtichChain: true
});
function ParticleKitChainProvider({
  chains: chains2,
  children,
  chain,
  userChains,
  provider,
  connectKit,
  connectId
}) {
  const [isEvm, setIsEvm] = useState(false);
  const [isSolana, setIsSolana] = useState(false);
  const [unsupportedChain, setUnsupportedChain] = useState(false);
  const updateIsEvm = useCallback((bool) => setIsEvm(bool), []);
  const updateIsSolana = useCallback((bool) => setIsSolana(bool), []);
  const renderChains = useMemo(() => {
    if (connectId && userChains && provider) {
      let rchains = [...userChains];
      const isEvm2 = provider && isEVMProvider(provider);
      const isSolana2 = provider && isSolanaProvider(provider);
      if (isSolana2 && connectId !== "particle") {
        rchains = rchains.filter((item) => [101, 102, 103].includes(item.id));
      }
      if (isEvm2 && connectId !== "particle") {
        rchains = rchains.filter((item) => {
          return ![101, 102, 103].includes(item.id) && item.name.toLowerCase() !== "tron";
        });
      }
      const rest = rchains.map((chain2) => {
        const chainInfo = chainUtils.getChainInfo(chain2);
        if (chainInfo) {
          return chainInfo;
        }
        return __spreadValues({
          icon: "",
          network: ""
        }, chain2);
      });
      return rest;
    }
    return [];
  }, [connectId, userChains, provider]);
  const isSwtichChain = useMemo(() => {
    var _a;
    if (!connectKit)
      return false;
    if (!connectId)
      return false;
    if (connectId === "particle")
      return true;
    const connector = (_a = connectKit == null ? void 0 : connectKit.getConnector(connectId)) == null ? void 0 : _a.connector;
    if (connector && connectId && !!(connector == null ? void 0 : connector.switchChain)) {
      return true;
    } else {
      return false;
    }
  }, [connectId, connectKit]);
  return /* @__PURE__ */ React.createElement(
    ParticleKitChainContext.Provider,
    {
      value: useMemo(
        () => ({
          chains: chains2,
          chain,
          isEvm,
          isSolana,
          updateIsSolana,
          updateIsEvm,
          unsupportedChain,
          setUnsupportedChain,
          renderChains,
          isSwtichChain
        }),
        [
          chains2,
          chain,
          isEvm,
          isSolana,
          updateIsSolana,
          updateIsEvm,
          unsupportedChain,
          setUnsupportedChain,
          renderChains,
          isSwtichChain
        ]
      )
    },
    children
  );
}
var useParticleKitChains = () => useContext(ParticleKitChainContext).chains;
var useInitialChainId = () => {
  var _a, _b;
  return (_b = (_a = useContext(ParticleKitChainContext)) == null ? void 0 : _a.chain) == null ? void 0 : _b.id;
};
var useIsEvm = () => {
  const { updateIsEvm, isEvm } = useContext(ParticleKitChainContext);
  return { updateIsEvm, isEvm };
};
var useIsSolana = () => {
  const { updateIsSolana, isSolana } = useContext(ParticleKitChainContext);
  return { updateIsSolana, isSolana };
};
var useSwitchChains = () => {
  const { isSwtichChain, renderChains } = useContext(ParticleKitChainContext);
  return { isSwtichChain, renderChains };
};
var useCurrentChain = () => {
  var _a;
  const initialChain = (_a = useContext(ParticleKitChainContext)) == null ? void 0 : _a.chain;
  if (!initialChain)
    return void 0;
  const findKey = Object.keys(ParticleChains).find((key) => ParticleChains[key].id === initialChain.id);
  if (findKey)
    return ParticleChains[findKey];
  return void 0;
};

// src/provider/ModalContext.tsx
import { AuthType as AuthType2 } from "@particle-network/auth-core";
import { AuthCoreContextProvider } from "@particle-network/auth-core-modal";
import { ParticleConnect, getPublicAddress as getPublicAddress2 } from "@particle-network/connectors";
import React7, { createContext as createContext3, useCallback as useCallback5, useContext as useContext3, useEffect as useEffect5, useMemo as useMemo5, useState as useState5 } from "react";

// src/components/ChainModal/index.tsx
import { useEthereum, useSolana } from "@particle-network/auth-core-modal";
import React3, { memo, useCallback as useCallback2, useEffect, useMemo as useMemo2, useState as useState2 } from "react";

// src/provider/I18nContext.tsx
import React2, { createContext as createContext2, useContext as useContext2 } from "react";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// src/locales/lang/en_US.js
var en_US_default = {
  language: "English",
  ConnectButton: {
    connectWallet: "Connect Wallet",
    wrongNetwork: "Wrong network"
  },
  ConnectModal: {
    email: "Email",
    phone: "Phone",
    google: "Google",
    apple: "Apple",
    facebook: "Facebook",
    microsoft: "Microsoft",
    linkedin: "Linkedin",
    github: "Github",
    discord: "Discord",
    twitter: "Twitter",
    twitch: "Twitch",
    title1: "What is a Wallet",
    title2: "Connect a Wallet",
    tip1: "A Home for your Tokens and NFTs",
    tip2: "You can manage your digital assets, for example send, receive and display.",
    tip3: "A New Way to Log In",
    tip4: " You can log in through your social account, and a crypto wallet will be automatically generated, simple but secure.",
    less: "Less",
    more: "More"
  },
  ConnectForm: {
    loading1: "Confirm connection in the Window",
    loading2: "Scan QR code with",
    copied_to_clipboard: "Copy to clipboard",
    copy_success: "Copy success"
  },
  ChainModal: {
    title: "Switch Networks",
    wrong: "Wrong network detected, switch or disconnect to continue.",
    connected: "Connected",
    confirm: "Confirm in Wallet",
    disconnect: "Disconnect",
    loading: "loading",
    switchTip: " Your wallet does not support switching networks from this app. Try switching networks from within your wallet instead."
  },
  AccountModal: {
    copied: "copied",
    logout: "Logout",
    wallet: "Wallet",
    buy: "Buy crypto",
    copy_address: "Copy address"
  }
};

// src/locales/lang/zh_CN.js
var zh_CN_default = {
  language: "\u7B80\u4F53\u4E2D\u6587",
  ConnectButton: {
    connectWallet: "\u8FDE\u63A5\u94B1\u5305",
    wrongNetwork: "\u7F51\u7EDC\u9519\u8BEF"
  },
  ConnectModal: {
    email: "\u90AE\u7BB1",
    phone: "\u7535\u8BDD",
    google: "Google",
    apple: "Apple",
    facebook: "Facebook",
    microsoft: "Microsoft",
    linkedin: "Linkedin",
    github: "Github",
    discord: "Discord",
    twitter: "Twitter",
    twitch: "Twitch",
    title1: "\u4EC0\u4E48\u662F\u94B1\u5305",
    title2: "\u8FDE\u63A5\u94B1\u5305",
    tip1: "\u4FDD\u62A4\u4F60\u5168\u90E8Token\u548CNFT\u7684\u5B89\u5168",
    tip2: "\u60A8\u53EF\u4EE5\u7BA1\u7406\u6570\u5B57\u8D44\u4EA7\uFF0C\u4F8B\u5982\u53D1\u9001\u3001\u63A5\u6536\u548C\u663E\u793A\u3002",
    tip3: "\u4E00\u79CD\u65B0\u7684\u767B\u5F55\u65B9\u5F0F",
    tip4: "\u60A8\u53EF\u4EE5\u901A\u8FC7\u793E\u4EA4\u8D26\u6237\u767B\u5F55\uFF0C\u52A0\u5BC6\u94B1\u5305\u5C06\u81EA\u52A8\u751F\u6210\uFF0C\u7B80\u5355\u4F46\u5F88\u5B89\u5168\u3002",
    less: "\u6536\u8D77",
    more: "\u66F4\u591A"
  },
  ConnectForm: {
    loading1: "\u786E\u8BA4\u8FDE\u63A5",
    loading2: "\u626B\u63CF\u4E8C\u7EF4\u7801",
    copied_to_clipboard: "\u590D\u5236\u5230\u7C98\u8D34\u677F",
    copy_success: "\u590D\u5236\u6210\u529F"
  },
  ChainModal: {
    title: "\u5207\u6362\u7F51\u7EDC",
    wrong: "\u68C0\u6D4B\u5230\u7F51\u7EDC\u9519\u8BEF\uFF0C\u8BF7\u5207\u6362\u6216\u65AD\u5F00\u540E\u7EE7\u7EED\u64CD\u4F5C\u3002",
    connected: "\u5DF2\u8FDE\u63A5",
    confirm: "\u5728\u94B1\u5305\u4E2D\u786E\u8BA4",
    disconnect: "\u65AD\u5F00\u8FDE\u63A5",
    loading: "\u52A0\u8F7D\u4E2D",
    switchTip: "\u60A8\u7684\u94B1\u5305\u4E0D\u652F\u6301\u4ECE\u6B64\u5E94\u7528\u5207\u6362\u7F51\u7EDC\u3002\u8BF7\u5728\u94B1\u5305\u4E2D\u5C1D\u8BD5\u5207\u6362\u7F51\u7EDC\u3002"
  },
  AccountModal: {
    copied: "\u5DF2\u590D\u5236",
    logout: "\u9000\u51FA\u767B\u5F55",
    wallet: "\u94B1\u5305",
    buy: "\u8D2D\u4E70\u6570\u5B57\u8D27\u5E01",
    copy_address: "\u590D\u5236\u5730\u5740"
  }
};

// src/locales/lang/ko_KR.js
var ko_KR_default = {
  language: "\u97E9\u6587",
  ConnectButton: {
    connectWallet: "\uC9C0\uAC11 \uC5F0\uACB0",
    wrongNetwork: "\uB124\uD2B8\uC6CC\uD06C \uC624\uB958"
  },
  ConnectModal: {
    email: "\uBA54\uC77C\uBC15\uC2A4",
    phone: "\uC804\uD654\uAE30",
    google: "Google",
    apple: "Apple",
    facebook: "Facebook",
    microsoft: "Microsoft",
    linkedin: "Linkedin",
    github: "Github",
    discord: "Discord",
    twitter: "Twitter",
    twitch: "Twitch",
    title1: "\uC9C0\uAC11\uC774 \uBB50\uC608\uC694",
    title2: "\uC9C0\uAC11 \uC5F0\uACB0",
    tip1: "\uBAA8\uB4E0 Token\uACFC NFT\uB97C \uC548\uC804\uD558\uAC8C \uC9C0\uCF1C\uB4DC\uB9BD\uB2C8\uB2E4.",
    tip2: "\uC804\uC1A1, \uC218\uC2E0 \uBC0F \uD45C\uC2DC\uC640 \uAC19\uC740 \uB514\uC9C0\uD138 \uC790\uC0B0\uC744 \uAD00\uB9AC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    tip3: "\uC0C8\uB85C\uC6B4 \uB85C\uADF8\uC778 \uBC29\uBC95",
    tip4: "\uC18C\uC15C \uACC4\uC815\uC744 \uD1B5\uD574 \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC73C\uBA70 \uC554\uD638\uD654 \uC9C0\uAC11\uC774 \uC790\uB3D9\uC73C\uB85C \uC0DD\uC131\uB418\uBA70 \uAC04\uB2E8\uD558\uC9C0\uB9CC \uC548\uC804\uD569\uB2C8\uB2E4.",
    less: "\uC9D1\uC5B4\uCE58\uC6B0\uB2E4",
    more: "\uCD94\uAC00"
  },
  ConnectForm: {
    loading1: "\uC811\uC18D \uD655\uC778",
    loading2: "QR\uCF54\uB4DC \uC2A4\uCE94",
    copied_to_clipboard: "\uD074\uB9BD\uBCF4\uB4DC\uB85C \uBCF5\uC0AC",
    copy_success: "\uBCF5\uC81C \uC131\uACF5"
  },
  ChainModal: {
    title: "\uB124\uD2B8\uC6CC\uD06C \uC804\uD658",
    wrong: "\uB124\uD2B8\uC6CC\uD06C \uC624\uB958\uAC00 \uBC1C\uACAC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC804\uD658\uD558\uAC70\uB098 \uBD84\uB9AC\uD55C \uD6C4 \uACC4\uC18D\uD558\uC2ED\uC2DC\uC624.",
    connected: "\uC811\uC18D\uB428",
    confirm: "\uC9C0\uAC11\uC5D0\uC11C \uD655\uC778",
    disconnect: "\uC5F0\uACB0 \uD574\uC81C",
    loading: "\uB85C\uB4DC \uC911",
    switchTip: "\uC9C0\uAC11\uC740 \uC774 \uC571\uC5D0\uC11C \uB124\uD2B8\uC6CC\uD06C \uC804\uD658\uC744 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\uC9C0\uAC11\uC5D0\uC11C \uB124\uD2B8\uC6CC\uD06C \uC804\uD658\uC744 \uC2DC\uB3C4\uD558\uC2ED\uC2DC\uC624."
  },
  AccountModal: {
    copied: "\uBCF5\uC0AC\uB428",
    logout: "\uB85C\uADF8\uC778 \uC885\uB8CC",
    wallet: "\uC9C0\uAC11",
    buy: "\uB514\uC9C0\uD138 \uD654\uD3D0 \uAD6C\uB9E4",
    copy_address: "\uC8FC\uC18C \uBCF5\uC0AC"
  }
};

// src/locales/lang/ja_JP.js
var ja_JP_default = {
  language: "\u65E5\u672C",
  ConnectButton: {
    connectWallet: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u63A5\u7D9A",
    wrongNetwork: "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u30A8\u30E9\u30FC"
  },
  ConnectModal: {
    email: "\u30E1\u30FC\u30EB\u30DC\u30C3\u30AF\u30B9",
    phone: "\u96FB\u8A71\u756A\u53F7",
    google: "Google",
    apple: "Apple",
    facebook: "Facebook",
    microsoft: "Microsoft",
    linkedin: "Linkedin",
    github: "Github",
    discord: "Discord",
    twitter: "Twitter",
    twitch: "Twitch",
    title1: "\u8CA1\u5E03\u3068\u306F",
    title2: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u63A5\u7D9A",
    tip1: "\u30C8\u30FC\u30AF\u30F3\u3068NFT\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u3059\u3079\u3066\u4FDD\u8B77",
    tip2: "\u9001\u4FE1\u3001\u53D7\u4FE1\u3001\u8868\u793A\u306A\u3069\u306E\u30C7\u30B8\u30BF\u30EB\u8CC7\u7523\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002",
    tip3: "\u65B0\u3057\u3044\u30ED\u30B0\u30A4\u30F3\u65B9\u6CD5",
    tip4: "\u30BD\u30FC\u30B7\u30E3\u30EB\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u3001\u6697\u53F7\u5316\u3055\u308C\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u81EA\u52D5\u7684\u306B\u751F\u6210\u3055\u308C\u307E\u3059\u304C\u3001\u7C21\u5358\u3067\u3059\u304C\u5B89\u5168\u3067\u3059\u3002",
    less: "\u3084\u3081\u308B",
    more: "\u8A73\u7D30"
  },
  ConnectForm: {
    loading1: "\u63A5\u7D9A\u306E\u78BA\u8A8D",
    loading2: "\u30B9\u30AD\u30E3\u30F32\u6B21\u5143\u30B3\u30FC\u30C9",
    copied_to_clipboard: "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC",
    copy_success: "\u30B3\u30D4\u30FC\u6210\u529F"
  },
  ChainModal: {
    title: "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306E\u5207\u308A\u66FF\u3048",
    wrong: "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u30A8\u30E9\u30FC\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002\u5207\u308A\u66FF\u3048\u307E\u305F\u306F\u5207\u65AD\u5F8C\u306B\u7D9A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    connected: "\u63A5\u7D9A\u6E08\u307F",
    confirm: "\u8CA1\u5E03\u306E\u4E2D\u3067\u78BA\u8A8D\u3059\u308B",
    disconnect: "\u63A5\u7D9A\u89E3\u9664",
    loading: "\u30ED\u30FC\u30C9\u4E2D",
    switchTip: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3067\u306F\u3001\u3053\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u8CA1\u5E03\u306E\u4E2D\u3067\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5207\u308A\u66FF\u3048\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  AccountModal: {
    copied: "\u30B3\u30D4\u30FC\u6E08\u307F",
    logout: "\u30ED\u30B0\u30AA\u30F3\u306E\u7D42\u4E86",
    wallet: "\u8CA1\u5E03",
    buy: "\u30C7\u30B8\u30BF\u30EB\u901A\u8CA8\u306E\u8CFC\u5165",
    copy_address: "\u30A2\u30C9\u30EC\u30B9\u306E\u30B3\u30D4\u30FC"
  }
};

// src/locales/lang/zh_TW.js
var zh_TW_default = {
  language: "\u7E41\u4F53\u4E2D\u6587",
  ConnectButton: {
    connectWallet: "\u9023\u63A5\u9322\u5305",
    wrongNetwork: "\u7DB2\u7D61\u932F\u8AA4"
  },
  ConnectModal: {
    email: "\u90F5\u7BB1",
    phone: "\u96FB\u8A71",
    google: "Google",
    apple: "Apple",
    facebook: "Facebook",
    microsoft: "Microsoft",
    linkedin: "Linkedin",
    github: "Github",
    discord: "Discord",
    twitter: "Twitter",
    twitch: "Twitch",
    title1: "\u4EC0\u9EBC\u662F\u9322\u5305",
    title2: "\u9023\u63A5\u9322\u5305",
    tip1: "\u4FDD\u8B77\u4F60\u5168\u90E8Token\u548CNFT\u7684\u5B89\u5168",
    tip2: "\u60A8\u53EF\u4EE5\u7BA1\u7406\u6578\u4F4D\u8CC7\u7522\uFF0C\u4F8B\u5982\u767C\u9001\u3001\u63A5\u6536\u548C\u986F\u793A\u3002",
    tip3: "\u4E00\u7A2E\u65B0\u7684\u767B\u5165\u7BA1\u9053",
    tip4: "\u60A8\u53EF\u4EE5\u901A\u904E\u793E\u4EA4\u5E33\u6236\u767B\u5165\uFF0C\u52A0\u5BC6\u9322\u5305\u5C07\u81EA\u52D5\u751F\u6210\uFF0C\u7C21\u55AE\u4F46\u5F88\u5B89\u5168\u3002",
    less: "\u6536\u8D77",
    more: "\u66F4\u591A"
  },
  ConnectForm: {
    loading1: "\u78BA\u8A8D\u9023\u63A5",
    loading2: "\u6383\u63CF\u4E8C\u7DAD\u78BC",
    copied_to_clipboard: "\u8907\u88FD\u5230\u526A\u8CBC\u677F",
    copy_success: "\u8907\u88FD\u6210\u529F"
  },
  ChainModal: {
    title: "\u5207\u63DB\u7DB2\u7D61",
    wrong: "\u6AA2\u6E2C\u5230\u7DB2\u7D61\u932F\u8AA4\uFF0C\u8ACB\u5207\u63DB\u6216\u65B7\u958B\u5F8C\u7E7C\u7E8C\u64CD\u4F5C\u3002",
    connected: "\u5DF2\u9023\u63A5",
    confirm: "\u5728\u9322\u5305\u4E2D\u78BA\u8A8D",
    disconnect: "\u65B7\u958B\u9023\u63A5",
    loading: "\u52A0\u8F09\u4E2D",
    switchTip: "\u60A8\u7684\u9322\u5305\u4E0D\u652F\u6301\u5F9E\u6B64\u61C9\u7528\u5207\u63DB\u7DB2\u7D61\u3002 \u8ACB\u5728\u9322\u5305\u4E2D\u5617\u8A66\u5207\u63DB\u7DB2\u7D61\u3002"
  },
  AccountModal: {
    copied: "\u5DF2\u8907\u88FD",
    logout: "\u767B\u51FA",
    wallet: "\u9322\u5305",
    buy: "\u8CFC\u8CB7\u6578\u4F4D\u8CA8\u5E63",
    copy_address: "\u8907\u88FD\u5730\u5740"
  }
};

// src/provider/I18nContext.tsx
var resources = {
  en: {
    translation: en_US_default
  },
  "zh-CN": {
    translation: zh_CN_default
  },
  ko: {
    translation: ko_KR_default
  },
  ja: {
    translation: ja_JP_default
  },
  "zh-TW": {
    translation: zh_TW_default
  },
  "zh-HK": {
    translation: zh_TW_default
  }
};
var i18nextInstance = i18n.createInstance();
i18nextInstance.init({
  fallbackLng: "en",
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false
  }
});
i18nextInstance.use(initReactI18next);
var I18nContext = createContext2(i18nextInstance);
var useTranslation = () => {
  const context = useContext2(I18nContext);
  return __spreadProps(__spreadValues({}, context), {
    i18n: i18nextInstance
  });
};
var I18nProvider = (props) => {
  return /* @__PURE__ */ React2.createElement(I18nContext.Provider, { value: i18nextInstance }, props.children);
};

// src/components/ChainModal/index.tsx
function ChainModal({ open, onClose, chains: chains2 }) {
  const { t } = useTranslation();
  const [switchLoading, setSwitchLoading] = useState2(0);
  const CurrentChainId = useInitialChainId();
  const network = useNetwork();
  const connectKit = useConnectKit();
  const { unsupportedChain } = useUnsupportedChain();
  const { disconnect } = useParticleConnect();
  const isSwitch = useMemo2(() => {
    var _a;
    if (!network || !network.connectId)
      return -1;
    if (network.connectId === "particle")
      return 1;
    const connector = (_a = connectKit == null ? void 0 : connectKit.getConnector(network.connectId)) == null ? void 0 : _a.connector;
    if (connector && network.connectId && !!(connector == null ? void 0 : connector.switchChain)) {
      return 1;
    } else {
      return -1;
    }
  }, [network.connectId, connectKit]);
  const { renderChains } = useSwitchChains();
  const modalCloseHandle = () => {
    onClose && onClose();
  };
  const logout = useCallback2((e) => __async(this, null, function* () {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    try {
      yield disconnect();
    } catch (error) {
    }
    onClose && onClose();
  }), []);
  const [overflow, setOverflow] = useState2([]);
  useEffect(() => {
    if (open) {
      const htmlOverFlow = document.getElementsByTagName("html")[0].style.overflow;
      const bodyOverFlow = document.getElementsByTagName("body")[0].style.overflow;
      setOverflow([htmlOverFlow, bodyOverFlow]);
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("html")[0].style.overflow = overflow[0];
      document.getElementsByTagName("body")[0].style.overflow = overflow[1];
      setOverflow([]);
    }
  }, [open]);
  const stopPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    return false;
  };
  const { switchChain } = useEthereum();
  const { switchChain: solanaSwitchChain } = useSolana();
  const switchLocalChain = useCallback2(
    (e, chain) => __async(this, null, function* () {
      var _a;
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      if (network.isSolana && network.connectId !== "particle")
        return;
      if (((_a = network.chain) == null ? void 0 : _a.id) === chain.id)
        throw new Error("The chain is same as the current chain");
      try {
        setSwitchLoading(chain.id);
        if (network.connectId === "particle") {
          if (chain.name.toLowerCase() === "solana") {
            yield solanaSwitchChain(chain.id);
            network.changeNetWork("solana");
          } else {
            yield switchChain(chain.id);
            network.changeNetWork("evm");
          }
        } else {
          yield connectKit.switchChain({ id: chain.id, name: chain.name });
        }
      } catch (error) {
      } finally {
        setSwitchLoading(0);
        modalCloseHandle();
      }
    }),
    [network]
  );
  const getChainDisplayName = (chainInfo) => {
    if (!chainInfo) {
      return "";
    }
    if (chainInfo.network === "Mainnet") {
      return chainInfo.fullname.replace(" Mainnet", "");
    } else {
      return chainInfo.fullname;
    }
  };
  return /* @__PURE__ */ React3.createElement(React3.Fragment, null, open ? /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(
    "div",
    {
      className: "particle-chain-modal-container center-center show",
      onClick: modalCloseHandle,
      onTouchStart: stopPropagation,
      onScroll: stopPropagation
    },
    /* @__PURE__ */ React3.createElement(
      "div",
      {
        className: "particle-chain-modal-box show",
        onTouchStart: stopPropagation,
        onScroll: stopPropagation
      },
      /* @__PURE__ */ React3.createElement("div", { className: "particle-chain-modal-close hover", onClick: modalCloseHandle }),
      /* @__PURE__ */ React3.createElement("div", { className: "particle-modal-title" }, t("ChainModal.title")),
      unsupportedChain && /* @__PURE__ */ React3.createElement("div", { className: "unsupported-tips" }, t("ChainModal.wrong")),
      isSwitch === 1 || unsupportedChain ? /* @__PURE__ */ React3.createElement("div", { className: "particle-chain-list-box" }, renderChains.map((chain) => /* @__PURE__ */ React3.createElement(
        "div",
        {
          key: `${chain.name}-${chain.id}`,
          className: `particle-chain-list-item center-start ${CurrentChainId === chain.id ? "active" : ""} ${network.isSolana && network.connectId !== "particle" ? "" : "item-hover"}`,
          onClick: (e) => switchLocalChain(e, chain)
        },
        /* @__PURE__ */ React3.createElement("img", { src: chain == null ? void 0 : chain.icon, alt: "" }),
        /* @__PURE__ */ React3.createElement("div", { className: "flex1" }, getChainDisplayName(chain)),
        CurrentChainId === chain.id ? /* @__PURE__ */ React3.createElement("div", { className: "particle-chain-active-connected center-end" }, t("ChainModal.connected"), " ", /* @__PURE__ */ React3.createElement("span", null)) : switchLoading === chain.id ? /* @__PURE__ */ React3.createElement("div", { className: "particle-chain-active-confirm center-end" }, t("ChainModal.confirm"), " ", /* @__PURE__ */ React3.createElement("span", null)) : void 0
      )), unsupportedChain && /* @__PURE__ */ React3.createElement("div", { onClick: logout, className: "particle-disconnect-btn center-center" }, t("ChainModal.disconnect"))) : isSwitch === -1 ? /* @__PURE__ */ React3.createElement("div", { className: "particle-chain-list-box particle-not-tips" }, t("ChainModal.switchTip")) : /* @__PURE__ */ React3.createElement("div", null, t("ChainModal.loading"))
    )
  )) : void 0);
}
var ChainModal_default = memo(ChainModal);

// src/components/ConnectModal/index.tsx
import { useConnect as useConnect2, useEthereum as useEthereum3, useSolana as useSolana3 } from "@particle-network/auth-core-modal";
import { chains } from "@particle-network/chains";
import { isIOS, isMobile } from "@particle-network/connectors";
import React6, { useCallback as useCallback4, useEffect as useEffect4, useState as useState4 } from "react";

// src/assets/images/what-img1.png
var what_img1_default = "data:image/png;base64,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";

// src/assets/images/what-img2.png
var what_img2_default = "data:image/png;base64,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";

// src/assets/social-icons/apple_icon.svg
var apple_icon_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICAgIHN0cm9rZTogI2Y1ZjVmNTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMDQwMDAwOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIHN0cm9rZTogbm9uZTsKICAgICAgfQoKICAgICAgLmNscy00IHsKICAgICAgICBmaWxsOiBub25lOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0i57uEXzExMzciIGRhdGEtbmFtZT0i57uEIDExMzciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMjAgLTUzNykiPgogICAgPGcgaWQ9IuefqeW9ol80MDAiIGRhdGEtbmFtZT0i55+p5b2iIDQwMCIgY2xhc3M9ImNscy0xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMjAgNTM3KSI+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiByeD0iNSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTQiIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHJ4PSI0LjUiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJhcHBsZSIgY2xhc3M9ImNscy0yIiBkPSJNMjEzLjEsMTM5LjExM2E0Ljk5LDQuOTksMCwwLDEsMi4yNTctMy45OTQsNC45NjksNC45NjksMCwwLDAtMy44Mi0yLjA4NGMtMS42NS0uMTc0LTMuMTI1Ljk1NS0zLjk5NC45NTUtLjc4MSwwLTIuMDg0LS45NTUtMy40NzMtLjg2OGE1LjIyOSw1LjIyOSwwLDAsMC00LjM0MSwyLjZjLTEuODIzLDMuMTI1LS40MzQsNy45LDEuMzg5LDEwLjUuODY4LDEuMywxLjkxLDIuNjkxLDMuMywyLjYsMS4zLS4wODcsMS44MjMtLjg2OCwzLjM4Ni0uODY4czIuMDg0Ljg2OCwzLjQ3My44NjgsMi4zNDQtMS4zLDMuMjEyLTIuNTE4YTEzLjQsMTMuNCwwLDAsMCwxLjQ3Ni0yLjk1Miw0LjYsNC42LDAsMCwxLTIuODY1LTQuMjU0bS0yLjY5MS03LjgxNGE0LjQ1Myw0LjQ1MywwLDAsMCwxLjA0Mi0zLjMsNC4zNTQsNC4zNTQsMCwwLDAtMy4wMzksMS41NjMsNC4xOTEsNC4xOTEsMCwwLDAtMS4xMjksMy4yMTIsMy44NywzLjg3LDAsMCwwLDMuMTI1LTEuNDc2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjcuMDUgNDEyLjQwNykiLz4KICA8L2c+Cjwvc3ZnPgo=";

// src/assets/social-icons/discord_icon.svg
var discord_icon_default = "data:image/svg+xml;base64,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";

// src/assets/social-icons/email_icon.svg
var email_icon_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICAgIHN0cm9rZTogI2Y1ZjVmNTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBzdHJva2U6IG5vbmU7CiAgICAgIH0KCiAgICAgIC5jbHMtMyB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9Iue7hF8xMjYiIGRhdGEtbmFtZT0i57uEIDEyNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMyMCAtNTM3KSI+CiAgICA8ZyBpZD0i55+p5b2iXzQwMCIgZGF0YS1uYW1lPSLnn6nlvaIgNDAwIiBjbGFzcz0iY2xzLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMyMCA1MzcpIj4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHJ4PSI1Ii8+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgcng9IjQuNSIvPgogICAgPC9nPgogICAgPHBhdGggaWQ9Iui3r+W+hF83IiBkYXRhLW5hbWU9Iui3r+W+hCA3IiBkPSJNMzguMzM0LDMwNy45NXYtNy40N2wtMy43OTEsMy45LDMuNzkxLDMuNTdtLTYuNC0uODkxYTMuMjQxLDMuMjQxLDAsMCwxLTQuNjc0LDBsLTIuMDM0LTIuMDkyLTQuMzY0LDQuMTEydi42ODlhMS42MTMsMS42MTMsMCwwLDAsMS41ODgsMS42MzRIMzYuNzQ2YTEuNjEzLDEuNjEzLDAsMCwwLDEuNTg4LTEuNjMydi0uNzEybC00LjM1NC00LjEtMi4wNDQsMi4xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMDQuOTg2IDI0Ny4yMzMpIi8+CiAgICA8cGF0aCBpZD0i6Lev5b6EXzgiIGRhdGEtbmFtZT0i6Lev5b6EIDgiIGQ9Ik0zNi43NzksMTI4SDIyLjQ4NGExLjYxMiwxLjYxMiwwLDAsMC0xLjU4NiwxLjYzMnYuMzQxbDYuOTU4LDcuMTU1YTIuNDY1LDIuNDY1LDAsMCwwLDMuNTUxLDBsNi45Ni03LjE1NXYtLjM0MUExLjYxNCwxLjYxNCwwLDAsMCwzNi43NzksMTI4bS0xNS45MTUsMy4wOTR2Ny40OTFsMy44LTMuNTgyLTMuOC0zLjkwOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzA0Ljk4NiA0MTYuNjE5KSIvPgogIDwvZz4KPC9zdmc+Cg==";

// src/assets/social-icons/facebook_icon.svg
var facebook_icon_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICAgIHN0cm9rZTogI2Y1ZjVmNTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMTg3N2YyOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIHN0cm9rZTogbm9uZTsKICAgICAgfQoKICAgICAgLmNscy00IHsKICAgICAgICBmaWxsOiBub25lOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0i57uEXzExMzgiIGRhdGEtbmFtZT0i57uEIDExMzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMjAgLTUzNykiPgogICAgPGcgaWQ9IuefqeW9ol80MDAiIGRhdGEtbmFtZT0i55+p5b2iIDQwMCIgY2xhc3M9ImNscy0xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMjAgNTM3KSI+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiByeD0iNSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTQiIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHJ4PSI0LjUiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJmYWNlYm9vayIgY2xhc3M9ImNscy0yIiBkPSJNMjg5LjY4MSw2MS45MzZWNjUuM2gtMmExLjg3MywxLjg3MywwLDAsMC0xLjQ3Ny40NTgsMi4xMDYsMi4xMDYsMCwwLDAtLjM4MiwxLjM3NXYyLjQwNmgzLjczbC0uNSwzLjc2OWgtMy4yMzR2OS42NjNoLTMuOVY3My4zaC0zLjI0NlY2OS41MzZoMy4yNDZWNjYuNzYxYTQuOTI2LDQuOTI2LDAsMCwxLDEuMzI0LTMuNjczLDQuOCw0LjgsMCwwLDEsMy41MjctMS4zMDUsMjEuMTI2LDIxLjEyNiwwLDAsMSwyLjkuMTUydjBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MC4zMTkgNDc5LjEyNSkiLz4KICA8L2c+Cjwvc3ZnPgo=";

// src/assets/social-icons/github_icon.svg
var github_icon_default = "data:image/svg+xml;base64,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";

// src/assets/social-icons/google_icon.svg
var google_icon_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICAgIHN0cm9rZTogI2Y1ZjVmNTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjZmJiYzA1OwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIGZpbGw6ICNlYTQzMzU7CiAgICAgIH0KCiAgICAgIC5jbHMtNCB7CiAgICAgICAgZmlsbDogIzM0YTg1MzsKICAgICAgfQoKICAgICAgLmNscy01IHsKICAgICAgICBmaWxsOiAjNDI4NWY0OwogICAgICB9CgogICAgICAuY2xzLTYgewogICAgICAgIHN0cm9rZTogbm9uZTsKICAgICAgfQoKICAgICAgLmNscy03IHsKICAgICAgICBmaWxsOiBub25lOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0i57uEXzExMzYiIGRhdGEtbmFtZT0i57uEIDExMzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMjAgLTUzNykiPgogICAgPGcgaWQ9IuefqeW9ol80MDAiIGRhdGEtbmFtZT0i55+p5b2iIDQwMCIgY2xhc3M9ImNscy0xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMjAgNTM3KSI+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtNiIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiByeD0iNSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTciIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHJ4PSI0LjUiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSLot6/lvoRfMTY3MCIgZGF0YS1uYW1lPSLot6/lvoQgMTY3MCIgY2xhc3M9ImNscy0yIiBkPSJNOS4xMiwyOTQuOTA4YTYuMTU4LDYuMTU4LDAsMCwxLC4zMjUtMS45NjVMNS44LDI5MC4yMTlhMTAuNDYzLDEwLjQ2MywwLDAsMCwwLDkuMzc0bDMuNjQxLTIuNzI5YTYuMTQzLDYuMTQzLDAsMCwxLS4zMjEtMS45NTciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMxOS4yMjYgMjU2LjU4OSkiLz4KICAgIDxwYXRoIGlkPSLot6/lvoRfMTY3MSIgZGF0YS1uYW1lPSLot6/lvoQgMTY3MSIgY2xhc3M9ImNscy0zIiBkPSJNNjYuODg5LDE1LjcyMmE2LjM0NCw2LjM0NCwwLDAsMSwzLjk4NSwxLjM5NWwzLjE0OS0zLjA3OWExMC45NDgsMTAuOTQ4LDAsMCwwLTE2Ljg0OSwzLjI0OWwzLjY0NCwyLjcyNGE2LjM2Niw2LjM2NiwwLDAsMSw2LjA3MS00LjI4OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY3Ljg1NSA1MjkuNTIpIi8+CiAgICA8cGF0aCBpZD0i6Lev5b6EXzE2NzIiIGRhdGEtbmFtZT0i6Lev5b6EIDE2NzIiIGNsYXNzPSJjbHMtNCIgZD0iTTY2Ljg4OSw2MDkuMjE3YTYuMzY5LDYuMzY5LDAsMCwxLTYuMDczLTQuMjg5bC0zLjY0MywyLjcyNGExMC44MTYsMTAuODE2LDAsMCwwLDkuNzE1LDUuOSwxMC40NDEsMTAuNDQxLDAsMCwwLDcuMDUyLTIuNjM4bC0zLjQ1OS0yLjYxOGE2LjgsNi44LDAsMCwxLTMuNTk1LjkyNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY3Ljg1NSAtNTEuNDY3KSIvPgogICAgPHBhdGggaWQ9Iui3r+W+hF8xNjczIiBkYXRhLW5hbWU9Iui3r+W+hCAxNjczIiBjbGFzcz0iY2xzLTUiIGQ9Ik01MjYuOTg0LDQyMi45MTZhOC42Miw4LjYyLDAsMCwwLS4yNDYtMS45MjRINTE2LjY1MXY0LjA4OWg1LjgwNmE0Ljc2Myw0Ljc2MywwLDAsMS0yLjIxLDMuMTY0bDMuNDU4LDIuNjE4YTEwLjQxOCwxMC40MTgsMCwwLDAsMy4yOC03Ljk0NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE4MS45MDggMTI4LjU4KSIvPgogIDwvZz4KPC9zdmc+Cg==";

// src/assets/social-icons/linkedin_icon.svg
var linkedin_icon_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICAgIHN0cm9rZTogI2Y1ZjVmNTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMDA3YmI1OwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIHN0cm9rZTogbm9uZTsKICAgICAgfQoKICAgICAgLmNscy00IHsKICAgICAgICBmaWxsOiBub25lOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0i57uEXzExMjIiIGRhdGEtbmFtZT0i57uEIDExMjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02NCAtNjE5LjYzNCkiPgogICAgPGcgaWQ9IuefqeW9ol80NDkiIGRhdGEtbmFtZT0i55+p5b2iIDQ0OSIgY2xhc3M9ImNscy0xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NCA2MTkuNjM0KSI+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiByeD0iNSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTQiIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHJ4PSI0LjUiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJsaW5rZWRpbiIgY2xhc3M9ImNscy0yIiBkPSJNMTE0LjI3OSwxMzNoMy41NDJWMTIxLjY0NWgtMy41NDJabTEuNzcyLTE3QTIuMDUsMi4wNSwwLDEsMSwxMTQsMTE4LjA0OSwyLjA1LDIuMDUsMCwwLDEsMTE2LjA1MSwxMTZabTQsNS42NDhoMy4zODZWMTIzLjJoLjA0OGEzLjcxLDMuNzEsMCwwLDEsMy4zNDMtMS44MzRjMy41NzQsMCw0LjIzNSwyLjM1LDQuMjM1LDUuNDA3VjEzM2gtMy41Mjl2LTUuNTE5YzAtMS4zMTgtLjAyNi0zLjAxMS0xLjgzNi0zLjAxMS0xLjgzOCwwLTIuMTE5LDEuNDM0LTIuMTE5LDIuOTE0VjEzM2gtMy41MjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQuMDMyIDUwOS42MzQpIi8+CiAgPC9nPgo8L3N2Zz4K";

// src/assets/social-icons/microsoft_icon.svg
var microsoft_icon_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICAgIHN0cm9rZTogI2Y1ZjVmNTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjZjI1MDIyOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIGZpbGw6ICM3ZmJhMDA7CiAgICAgIH0KCiAgICAgIC5jbHMtNCB7CiAgICAgICAgZmlsbDogIzAwYTRlZjsKICAgICAgfQoKICAgICAgLmNscy01IHsKICAgICAgICBmaWxsOiAjZmZiOTAwOwogICAgICB9CgogICAgICAuY2xzLTYgewogICAgICAgIHN0cm9rZTogbm9uZTsKICAgICAgfQoKICAgICAgLmNscy03IHsKICAgICAgICBmaWxsOiBub25lOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0i57uEXzExMjEiIGRhdGEtbmFtZT0i57uEIDExMjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02NCAtNjE4LjYzNCkiPgogICAgPGcgaWQ9IuefqeW9ol80NDciIGRhdGEtbmFtZT0i55+p5b2iIDQ0NyIgY2xhc3M9ImNscy0xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NCA2MTguNjM0KSI+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtNiIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiByeD0iNSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTciIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHJ4PSI0LjUiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJtaWNyb3NvZnQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY5LjQxOCA2MjQuMDUyKSI+CiAgICAgIDxwYXRoIGlkPSLot6/lvoRfMTY4MyIgZGF0YS1uYW1lPSLot6/lvoQgMTY4MyIgY2xhc3M9ImNscy0yIiBkPSJNMCwwSDguNjMxVjguNjMxSDBaIi8+CiAgICAgIDxwYXRoIGlkPSLot6/lvoRfMTY4NCIgZGF0YS1uYW1lPSLot6/lvoQgMTY4NCIgY2xhc3M9ImNscy0zIiBkPSJNNTM3LjQwOCwwaDguNjMxVjguNjMxaC04LjYzMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MjcuODc2KSIvPgogICAgICA8cGF0aCBpZD0i6Lev5b6EXzE2ODUiIGRhdGEtbmFtZT0i6Lev5b6EIDE2ODUiIGNsYXNzPSJjbHMtNCIgZD0iTTAsNTM3LjQwOEg4LjYzMXY4LjYzMUgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNTI3Ljg3NikiLz4KICAgICAgPHBhdGggaWQ9Iui3r+W+hF8xNjg2IiBkYXRhLW5hbWU9Iui3r+W+hCAxNjg2IiBjbGFzcz0iY2xzLTUiIGQ9Ik01MzcuNDA4LDUzNy40MDhoOC42MzF2OC42MzFoLTguNjMxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUyNy44NzYgLTUyNy44NzYpIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

// src/assets/social-icons/phone_icon.svg
var phone_icon_default = "data:image/svg+xml;base64,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";

// src/assets/social-icons/twitch_icon.svg
var twitch_icon_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjOTI0NmZmOwogICAgICB9CgogICAgICAuY2xzLTIgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSLnu4RfMTIwOCIgZGF0YS1uYW1lPSLnu4QgMTIwOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMyMCAtNTM3KSI+CiAgICA8cmVjdCBpZD0i55+p5b2iXzQwMCIgZGF0YS1uYW1lPSLnn6nlvaIgNDAwIiBjbGFzcz0iY2xzLTEiIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgcng9IjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMyMCA1MzcpIi8+CiAgICA8cGF0aCBpZD0i55+p5b2iXzQ0MyIgZGF0YS1uYW1lPSLnn6nlvaIgNDQzIiBjbGFzcz0iY2xzLTIiIGQ9Ik0wLDBIMTFhMCwwLDAsMCwxLDAsMFYzYTgsOCwwLDAsMS04LDhIMGEwLDAsMCwwLDEsMCwwVjBBMCwwLDAsMCwxLDAsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMSA1NDUpIi8+CiAgICA8cGF0aCBpZD0idHdpdGNoIiBkPSJNNTkuNjE2LDMuMzQ0SDU4LjQ1OFY2Ljg4OWgxLjE1OFptLTMuMTgyLS4wMTVINTUuMjc2VjYuODc2aDEuMTU4Wk01MS41MTMsMCw0OC42MiwyLjk1NVYxMy41OTJoMy40NzJ2Mi45NTVsMi44OTMtMi45NTVINTcuM2w1LjIwOS01LjMxOVYwWm05LjgzOSw3LjY4NC0yLjMxNSwyLjM2M0g1Ni43MjJMNTQuNywxMi4xMTVWMTAuMDQ3aC0yLjZWMS4xODJoOS4yNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI3OS45MzUgNTQzLjgyNykiLz4KICA8L2c+Cjwvc3ZnPgo=";

// src/assets/social-icons/twitter_icon.svg
var twitter_icon_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICAgIHN0cm9rZTogI2Y1ZjVmNTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMWRhMWYyOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIHN0cm9rZTogbm9uZTsKICAgICAgfQoKICAgICAgLmNscy00IHsKICAgICAgICBmaWxsOiBub25lOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0i57uEXzEyMDciIGRhdGEtbmFtZT0i57uEIDEyMDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMjAgLTUzNykiPgogICAgPGcgaWQ9IuefqeW9ol80MDAiIGRhdGEtbmFtZT0i55+p5b2iIDQwMCIgY2xhc3M9ImNscy0xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMjAgNTM3KSI+CiAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMyIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiByeD0iNSIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTQiIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHJ4PSI0LjUiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJ0d2l0dGVyIiBjbGFzcz0iY2xzLTIiIGQ9Ik0xMTQuMTQ1LDE3NS43NjFhNy41LDcuNSwwLDAsMS0yLjE1My41NzksMy43MywzLjczLDAsMCwwLDEuNjQ0LTIuMDYxLDcuMzgyLDcuMzgyLDAsMCwxLTIuMzcyLjksMy43NDIsMy43NDIsMCwwLDAtNi40NzEsMi41NTksNC4yOTQsNC4yOTQsMCwwLDAsLjA5Mi44NTcsMTAuNjI1LDEwLjYyNSwwLDAsMS03LjcwOS0zLjkxNCwzLjc1LDMuNzUsMCwwLDAsMS4xNTgsNSwzLjc3MSwzLjc3MSwwLDAsMS0xLjY5MS0uNDc2di4wNDZhMy43NCwzLjc0LDAsMCwwLDMsMy42NywzLjk2MSwzLjk2MSwwLDAsMS0uOTg0LjEyN0E0Ljk3NSw0Ljk3NSwwLDAsMSw5Ny45NSwxODNhMy43NDYsMy43NDYsMCwwLDAsMy41LDIuNTk0LDcuNDkzLDcuNDkzLDAsMCwxLTQuNjQyLDEuNiw3LjY0NCw3LjY0NCwwLDAsMS0uOS0uMDQ2LDEwLjY0NSwxMC42NDUsMCwwLDAsMTYuMzgxLTguOTY0YzAtLjE2MiwwLS4zMjQtLjAxMS0uNDg3QTguMDUyLDguMDUyLDAsMCwwLDExNC4xNDUsMTc1Ljc2MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyOS42MTIgMzcwLjA4OSkiLz4KICA8L2c+Cjwvc3ZnPgo=";

// src/hooks/useParticleConnect.ts
import { AuthCoreEvent, AuthType, isConnected, particleAuth } from "@particle-network/auth-core";
import { useConnect, useEthereum as useEthereum2, useSolana as useSolana2 } from "@particle-network/auth-core-modal";
import { getEVMChainById, getPublicAddress, isEVMProvider as isEVMProvider2 } from "@particle-network/connectors";
import { walletEntryPlugin } from "@particle-network/wallet";
import { useCallback as useCallback3, useEffect as useEffect2 } from "react";

// src/hooks/useNetwork.ts
import { useMemo as useMemo3 } from "react";
function useNetwork() {
  const chains2 = useParticleKitChains();
  const chain = useCurrentChain();
  const { isEvm, updateIsEvm } = useIsEvm();
  const { isSolana, updateIsSolana } = useIsSolana();
  const connectKit = useConnectKit();
  const { connectId } = useAccountInfo();
  return useMemo3(
    () => ({
      chain,
      chains: chains2,
      isEvm,
      isSolana,
      network: isEvm ? "evm" : isSolana ? "solana" : void 0,
      connectId,
      changeNetWork: (chainType) => {
        localStorage.setItem("particle_connect_chain_type", chainType);
        switch (chainType) {
          case "solana":
            updateIsEvm == null ? void 0 : updateIsEvm(false);
            updateIsSolana == null ? void 0 : updateIsSolana(true);
            break;
          case "evm":
            updateIsEvm == null ? void 0 : updateIsEvm(true);
            updateIsSolana == null ? void 0 : updateIsSolana(false);
            break;
        }
      }
    }),
    [chain, chains2, isEvm, isSolana, updateIsEvm, updateIsSolana, connectKit, connectId]
  );
}

// src/hooks/useParticleConnect.ts
function useParticleConnect() {
  const { updateParticleProvider, updateAccount, updateConnectId } = useConnectAction();
  const { updateChain } = useChain();
  const { setAccountLoading, connectId, particleProvider } = useAccountInfo();
  const { changeNetWork } = useNetwork();
  const { userChains } = useUserChains();
  const { setUnsupportedChain } = useUnsupportedChain();
  const isCache = useIsCacheProvider();
  const connectKit = useConnectKit();
  const connectSuccess = useCallback3(
    (provider, id) => __async(this, null, function* () {
      const account = yield getPublicAddress(provider);
      updateParticleProvider == null ? void 0 : updateParticleProvider(provider);
      updateAccount == null ? void 0 : updateAccount(account);
      setAccountLoading == null ? void 0 : setAccountLoading(false);
      updateConnectId == null ? void 0 : updateConnectId(id != null ? id : "");
      if (isEVMProvider2(provider)) {
        const chainId = yield provider.request({ method: "eth_chainId" });
        const chain = getEVMChainById(Number(chainId));
        if (chain) {
          updateChain == null ? void 0 : updateChain({
            id: Number(chainId),
            name: chain.name
          });
        }
        changeNetWork("evm");
        setUnsupportedChain == null ? void 0 : setUnsupportedChain(!chain || !userChains.find((x) => x.id === chain.id));
      } else {
        updateChain == null ? void 0 : updateChain({
          id: 101,
          name: "Solana"
        });
        changeNetWork("solana");
        setUnsupportedChain == null ? void 0 : setUnsupportedChain(false);
      }
    }),
    [updateChain, changeNetWork, getEVMChainById]
  );
  const { connect: connectAuthCore, disconnect: disconnectAuthCore } = useConnect();
  const { provider: evmProvider } = useEthereum2();
  const { wallet: solanaWallet } = useSolana2();
  const { connectionStatus } = useConnect();
  useEffect2(() => {
    const chain = userChains[0];
    const onAuthCoreConnect = () => {
      connectSuccess(chain.name.toLowerCase() === "solana" ? solanaWallet : evmProvider, "particle");
    };
    particleAuth.on(AuthCoreEvent.ParticleAuthConnect, onAuthCoreConnect);
    return () => {
      particleAuth.off(AuthCoreEvent.ParticleAuthConnect, onAuthCoreConnect);
    };
  }, [connectSuccess, userChains]);
  useEffect2(() => {
    if (connectionStatus === "loading") {
      setAccountLoading == null ? void 0 : setAccountLoading(true);
    } else if (connectionStatus === "connected" || connectionStatus === "disconnected") {
      setAccountLoading == null ? void 0 : setAccountLoading(false);
    }
  }, [connectionStatus]);
  useEffect2(() => {
    var _a;
    if (connectId !== "particle") {
      if (particleProvider) {
        if (isEVMProvider2(particleProvider)) {
          walletEntryPlugin.setWalletCore({
            ethereum: particleProvider
          });
        } else {
          Object.defineProperty(particleProvider, "chainId", {
            value: 101,
            writable: false
          });
          Object.defineProperty(particleProvider, "selectedAddress", {
            value: ((_a = particleProvider.publicKey) == null ? void 0 : _a.toBase58()) || null,
            writable: false
          });
          walletEntryPlugin.setWalletCore({
            solana: particleProvider
          });
        }
        setTimeout(() => {
          walletEntryPlugin.walletEntryCreate();
        }, 200);
      } else {
        walletEntryPlugin.walletEntryDestroy();
      }
    }
  }, [connectId, particleProvider]);
  const connect = (_a) => __async(this, null, function* () {
    var _b = _a, { preferredAuthType, id } = _b, options = __objRest(_b, ["preferredAuthType", "id"]);
    if (connectKit) {
      if (id === "particle") {
        const chain = userChains[0];
        if (preferredAuthType === AuthType.phone) {
          yield connectAuthCore({
            phone: "",
            chain
          });
        } else if (preferredAuthType === AuthType.email) {
          yield connectAuthCore({
            email: "",
            chain
          });
        } else {
          yield connectAuthCore({
            socialType: preferredAuthType,
            prompt: "select_account",
            chain
          });
        }
        yield connectSuccess(chain.name.toLowerCase() === "solana" ? solanaWallet : evmProvider, "particle");
        return evmProvider;
      }
      const provider = yield connectKit.connect(id, options);
      yield connectSuccess(provider, id);
      return provider;
    } else {
      return Promise.reject("error : connect no found  connectKit");
    }
  });
  const disconnect = (options) => __async(this, null, function* () {
    var _a;
    try {
      if (connectKit) {
        if (connectId === "particle") {
          yield disconnectAuthCore();
        } else {
          yield connectKit.disconnect(options);
        }
        updateParticleProvider == null ? void 0 : updateParticleProvider(void 0);
        updateAccount == null ? void 0 : updateAccount("");
        updateConnectId == null ? void 0 : updateConnectId("");
        setUnsupportedChain == null ? void 0 : setUnsupportedChain(false);
        if (typeof window !== "undefined") {
          (_a = window == null ? void 0 : window.localStorage) == null ? void 0 : _a.removeItem("WALLETCONNECT_DEEPLINK_CHOICE");
        }
        changeNetWork == null ? void 0 : changeNetWork("");
        updateChain == null ? void 0 : updateChain(void 0);
      }
      return Promise.resolve("no connect");
    } catch (error) {
      return Promise.reject(error);
    }
  });
  const cacheconnect = () => __async(this, null, function* () {
    var _a;
    if (connectKit && isCache) {
      if (isConnected()) {
        const chain = userChains[0];
        const chainType = localStorage.getItem("particle_connect_chain_type");
        let provider = chain.name.toLowerCase() === "solana" ? solanaWallet : evmProvider;
        if (chainType === "solana" && userChains.some((chain2) => chain2.name.toLowerCase() === "solana")) {
          provider = solanaWallet;
        }
        yield connectSuccess(provider, "particle");
        return provider;
      } else {
        const provider = yield connectKit.connectToCachedProvider().catch((e) => {
          setAccountLoading == null ? void 0 : setAccountLoading(false);
          return void 0;
        });
        if (provider) {
          yield connectSuccess(provider, ((_a = connectKit == null ? void 0 : connectKit.cachedProviderId) == null ? void 0 : _a.call(connectKit)) || "");
        } else {
          setAccountLoading == null ? void 0 : setAccountLoading(false);
        }
        return provider;
      }
    }
    setAccountLoading == null ? void 0 : setAccountLoading(false);
    return void 0;
  });
  return {
    connectKit,
    connect,
    disconnect,
    cacheconnect,
    _connectSuccess: connectSuccess
  };
}

// src/hooks/useWalletMeta.ts
function useWalletMetas() {
  return __async(this, null, function* () {
    const { connectKit } = useParticleConnect();
    if (connectKit && connectKit.walletMetas) {
      const walletMetas = yield connectKit.walletMetas();
      return walletMetas;
    }
    return Promise.resolve([]);
  });
}

// src/components/ConnectForm/index.tsx
import React5, { useState as useState3, useEffect as useEffect3 } from "react";

// src/components/ConnectForm/qr.tsx
import QRCodeUtil from "qrcode";
import React4, { useMemo as useMemo4 } from "react";
var generateMatrix = (value, errorCorrectionLevel) => {
  const arr = Array.prototype.slice.call(QRCodeUtil.create(value, { errorCorrectionLevel }).modules.data, 0);
  const sqrt = Math.sqrt(arr.length);
  return arr.reduce(
    (rows, key, index) => (index % sqrt === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows,
    []
  );
};
var QRCode = ({
  ecl = "M",
  logo,
  logoBackgroundColor: givenLogoBackgroundColor,
  logoMargin = 5,
  logoSize = 34,
  size = 150,
  value = "QR Code",
  randomDotSize = false
}) => {
  const logoBackgroundColor = givenLogoBackgroundColor;
  const href = logo;
  const dots = useMemo4(() => {
    const dots2 = [];
    const matrix = generateMatrix(value, ecl);
    const cellSize = size / matrix.length;
    const qrList = [
      { x: 0, y: 0 },
      { x: 1, y: 0 },
      { x: 0, y: 1 }
    ];
    qrList.forEach(({ x, y }) => {
      const x1 = (matrix.length - 7) * cellSize * x;
      const y1 = (matrix.length - 7) * cellSize * y;
      for (let i = 0; i < 3; i++) {
        dots2.push(
          /* @__PURE__ */ React4.createElement(
            "rect",
            {
              fill: i % 2 !== 0 ? "white" : "black",
              height: cellSize * (7 - i * 2),
              rx: (i - 3) * -10 + (i === 0 ? 2 : 0),
              ry: (i - 3) * -10 + (i === 0 ? 2 : 0),
              width: cellSize * (7 - i * 2),
              x: x1 + cellSize * i,
              y: y1 + cellSize * i
            }
          )
        );
      }
    });
    const clearArenaSize = Math.floor((logoSize * 1.5 + 3) / cellSize);
    const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
    const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
    matrix.forEach((row, i) => {
      row.forEach((column, j) => {
        if (matrix[i][j]) {
          if (!(i < 7 && j < 7 || i > matrix.length - 8 && j < 7 || i < 7 && j > matrix.length - 8)) {
            if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd && i < j + clearArenaSize / 2 && j < i + clearArenaSize / 2 + 1)) {
              dots2.push(
                /* @__PURE__ */ React4.createElement(
                  "circle",
                  {
                    cx: i * cellSize + cellSize / 2,
                    cy: j * cellSize + cellSize / 2,
                    fill: "black",
                    r: cellSize / (randomDotSize ? (Math.random() + 1) * 2 : 2.5)
                  }
                )
              );
            }
          }
        }
      });
    });
    return dots2;
  }, [ecl, logoSize, size, value, randomDotSize]);
  const logoPosition = size / 2 - logoSize / 2 - logoMargin;
  const logoWrapperSize = logoSize + logoMargin * 2;
  return /* @__PURE__ */ React4.createElement("svg", { height: size / 2, width: size / 2, viewBox: `0 0 ${size} ${size}` }, /* @__PURE__ */ React4.createElement("defs", null, /* @__PURE__ */ React4.createElement("clipPath", { id: "clip-wrapper" }, /* @__PURE__ */ React4.createElement("rect", { height: logoWrapperSize, width: logoWrapperSize })), /* @__PURE__ */ React4.createElement("clipPath", { id: "clip-logo" }, /* @__PURE__ */ React4.createElement("rect", { height: logoSize, width: logoSize }))), /* @__PURE__ */ React4.createElement("rect", { fill: "white", height: size, width: size }), dots, logo && /* @__PURE__ */ React4.createElement("g", null, /* @__PURE__ */ React4.createElement(
    "rect",
    {
      fill: logoBackgroundColor,
      height: logoWrapperSize,
      width: logoWrapperSize,
      x: logoPosition,
      y: logoPosition
    }
  ), /* @__PURE__ */ React4.createElement("g", null, /* @__PURE__ */ React4.createElement(
    "image",
    {
      height: logoSize,
      href,
      preserveAspectRatio: "xMidYMid slice",
      width: logoSize,
      x: logoPosition + logoMargin,
      y: logoPosition + logoMargin
    }
  ))));
};
var qr_default = QRCode;

// src/assets/images/loading.png
var loading_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAABZFJREFUaEPtmk1oHVUUx8+5b6QW3cVuNBFdKCQz944P06R1YRW0FRH8SuJCF1pqu0gV/CjiRhN3gl9IFZpYFayCSaQKiqYIpgqmaaPvzb0zRslCQbux6krTIPPmyIQX8ePN3Dtv5j3SNAOPLO45/3N+9/sjCOfZh+cZL2wAr/cW32jhjRZeZzXQti7teV4nAKz8ELErrkci+hEAfop/ruvGf1v+tQy4UqlcZVnW9UR0GyDeDqBdEQiIPkDED8Mw/LxcLi+2gr5wYCnlA4D4IABsz5nwLBCNCyHeyKnzL/fCgH3fvzsi2g8ANxSZIADMMMSDjuO8V4RubuB4bCJjLwPAnUUklKJxlKLo4bxjPRewlPImQHwTAC5rMeyq/Gkgul8I8Wmz8ZoGllIOA+LBZgPn8iPaL4R4pRmNpoC9IBjAKJpsJmBRPsTYoGvbU1n1MgN7nucgYypjoOOAOFlCPBWG4RnLss7E/mEYbrEsa0uNaCsQDQLAjiy6FEXcdV0/i08m4Lm5uY4LN28+joi2URCi8ahUeu0a2z5pYl8Ngj5Wq+2pL2taFyIKls+e3dHf3/+r1rhukAlY+v4kEA3oxIloiiE+yzmf19k2KldK9UZETyCiNhYgTgnHiXuH0WcMXF9ntWMmhnWFME4gLUtPykkTaIY4YLpOGwNLpT7TbiqInhFCPG1U1YZGUspRQHxKYz4jOL/RRNIIuL5dfD1NEAFGOecjJkGz2iilRgggvSKJdptsQ42APSlPIGJ/YqJEbwsh7ssKksVeSnkEEO9N8iGiOVeIbTpNLXAQBD21KApShSyrV3R3f6ULlqdcLixcC2GYOgmWGLNt2/5G0xPT05C+/wgQvZBohTgmHGdfHhhTX+n7h4Bob0oujwrHeTEXsKfUJwiwK7ErRdE213XnTJPOY+d5Xj8ydiIxF4Bpl/NbcgFLpSglwEmX8+SxnYcuwddTag4B+pKkBeepwzS1sH70i69hGn4I8Djn/PkWcCVKKqUeI4DnUnpcV9oRMhVYSrkdEL9MEmeIfY7jnGonsO/7WyOi5K0q0XVCiNmURkpOV0o5CIgTSRa1MLyyXC7/0E7gSqVyRcmyvk+MSTQkhEg8yaW3sGaGpii62HXdP9oJ7HneRcjY783O1OcccAwqfT+++bi0ITTRPiHE2Lrp0ivASn0EALcmAN+cdgV0zk1aMWQQBHYtihod/I8JzhP3DLFv+rK0uNiJy8uJyxIhDruO82o7x/BqrIWFhY4/w/DJlcsIol8QYJpzfkSXi3YvnbbxiO+MTY9lukTaVa4HlvL9+lNJw5xqiH3lNq/FeSpHC+x53h5kbDxl3RsTQrTl8JAHdNVXC1ytVq9mpdJ3qcGIeoUQLT0eFgGrnbRWg0il4q1a2uF6QnB+T1FJtVJH28Jx8KpSuxnAYU0rTwohhlqZbBHaRsD1xX5Gd1GOACOc89EiEmuVhjGw6fMKAYy4axjaGLjeykcB4A5d7SPAW1Gp9JLb0/O1zrbd5ZmAgyC4PKzVZhGx8cb9v9kTjUWl0mHTp5Z2wGcCrk9gOxnAdJbk4itUBJhgjH3BGPt5aWnpTG9v71IWjaJsMwPHgZVSDxFA/Oqf5zsdLwAIcIBzvpBHKItvU8B16CECeDdLsCTbEmMdtm3/VoSWTqNp4JVJTEoOiDF0ty5QWnl8KedyfiCPhqlvLuA4yPz8/CUXbNp0CAHuMg36PzvEj4XjND7QNy3a2DE38Kps/cJvWLc5aZhGG18vCgNeBVnZhiLuBSLzC/oc/6SStQMUDvw3eLVqM8vaiUS7KO2phugdV4jEV8GsQDr7lgH/MzARoe/7nSFAlwXQSYidSBQCwLec82O6JIssbwtwkQnn1doAzluDa91/o4XXegvlzW+jhfPW4Fr3/ws0MgpbOUdCfQAAAABJRU5ErkJggg==";

// src/components/ConnectForm/index.tsx
function ConnectForm({
  authItem,
  mobileUri
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState3(true);
  const [isCopy, setIsCopy] = useState3(false);
  const [copyString, setCopyString] = useState3(t("ConnectForm.copied_to_clipboard"));
  const [qrcode, setQrcode] = useState3({
    value: "",
    logo: ""
  });
  useEffect3(() => {
    const init = () => __async(this, null, function* () {
      setLoading(true);
      setQrcode({
        value: "",
        logo: ""
      });
      if (authItem && authItem.key) {
        if ((authItem == null ? void 0 : authItem.methods) === "qrcode" && mobileUri) {
          if (mobileUri) {
            setQrcode({
              value: mobileUri,
              logo: authItem.icon
            });
            setLoading(false);
          }
        }
      }
    });
    init();
  }, [authItem, mobileUri]);
  const copyText = (text) => {
    try {
      if (isCopy)
        return;
      setIsCopy(true);
      setCopyString(t("ConnectForm.copy_success") + "!");
      navigator.clipboard.writeText(text);
      setTimeout(() => {
        setCopyString(t("ConnectForm.copied_to_clipboard"));
        setIsCopy(false);
      }, 1e3);
    } catch (error) {
    }
  };
  return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement("div", { className: "particle-connect-form-contaier center-center flex-column" }, loading ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement("div", { className: "center-center flex-column particle-loading" }, /* @__PURE__ */ React5.createElement("img", { src: authItem == null ? void 0 : authItem.icon, alt: "" }), /* @__PURE__ */ React5.createElement("h3", null, " ", (authItem == null ? void 0 : authItem.methods) === "qrcode" && (authItem == null ? void 0 : authItem.name) !== "MetaMask" ? "Connect with" : "Opening", " ", authItem == null ? void 0 : authItem.name, "..."), /* @__PURE__ */ React5.createElement("p", null, t("ConnectForm.loading1")), /* @__PURE__ */ React5.createElement("p", null, /* @__PURE__ */ React5.createElement(
    "img",
    {
      className: "particle-loading-img",
      width: 30,
      height: 30,
      src: loading_default,
      alt: ""
    }
  )))) : /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement("div", { className: "particle-qrcode center-center" }, qrcode.value && /* @__PURE__ */ React5.createElement(
    qr_default,
    {
      value: qrcode.value,
      logo: qrcode.logo,
      logoBackgroundColor: "#fff",
      size: 700,
      logoSize: 120,
      ecl: "H",
      logoMargin: 20
    }
  )), qrcode.value && /* @__PURE__ */ React5.createElement("div", { className: "particle-copy-uri", onClick: () => copyText(qrcode.value) }, copyString), /* @__PURE__ */ React5.createElement("div", { className: "particle-form-footer center-center flex-column" }, /* @__PURE__ */ React5.createElement("span", null, t("ConnectForm.loading2"), " ", authItem == null ? void 0 : authItem.name)))));
}
var ConnectForm_default = ConnectForm;

// src/components/ConnectModal/index.tsx
var AuthGroup = [
  {
    name: "Email",
    key: "email",
    icon: email_icon_default,
    methods: "browser",
    data: {}
  },
  {
    name: "Phone",
    key: "phone",
    icon: phone_icon_default,
    methods: "browser",
    data: {}
  },
  {
    name: "Google",
    key: "google",
    icon: google_icon_default,
    methods: "browser",
    data: {}
  },
  {
    name: "Apple",
    key: "apple",
    icon: apple_icon_default,
    methods: "browser",
    data: {}
  },
  {
    name: "Facebook",
    key: "facebook",
    icon: facebook_icon_default,
    methods: "browser",
    data: {}
  },
  {
    name: "Microsoft",
    key: "microsoft",
    icon: microsoft_icon_default,
    methods: "browser",
    data: {}
  },
  {
    name: "Linkedin",
    key: "linkedin",
    icon: linkedin_icon_default,
    methods: "browser",
    data: {}
  },
  {
    name: "Github",
    key: "github",
    icon: github_icon_default,
    methods: "browser",
    data: {}
  },
  {
    name: "Discord",
    key: "discord",
    icon: discord_icon_default,
    methods: "browser"
  },
  {
    name: "Twitch",
    key: "twitch",
    icon: twitch_icon_default,
    methods: "browser"
  },
  {
    name: "Twitter",
    key: "twitter",
    icon: twitter_icon_default,
    methods: "browser"
  }
];
function ConnectModal({ open, onClose, closeAllModal }) {
  var _a;
  const { connect, connectKit, _connectSuccess } = useParticleConnect();
  const isPhone = isMobile();
  const { walletSort } = useWalletSort();
  const particleAuthSort = useParticleAuthTypes();
  const wallets = useWalletMetas();
  const [isMoce, setIsMore] = useState4(false);
  const [authKey, setAuthKey] = useState4("");
  const [authItem, setAuthItem] = useState4(void 0);
  const [walletMetas, setWalletMetas] = useState4([]);
  const [loginStep, setLoginStep] = useState4("1");
  const [mobileUri, setMobileUri] = useState4("");
  const [overflow, setOverflow] = useState4([]);
  const { t } = useTranslation();
  const { connectId } = useAccountInfo();
  const initWallets = () => {
    if (open) {
      wallets.then((res) => {
        const walletsArr = res.filter((item) => {
          var _a2, _b;
          if (isMobile() && item.name === "Phantom") {
            if (typeof window === "undefined" || !((_b = (_a2 = window.phantom) == null ? void 0 : _a2.solana) == null ? void 0 : _b.isPhantom)) {
              return false;
            }
          }
          return true;
        }).map((item) => {
          return {
            name: item.name,
            key: item.id,
            icon: item.iconUrl,
            methods: "qrcode",
            data: item
          };
        });
        setWalletMetas(walletsArr);
        setIsMore(walletsArr.length === 0);
      });
    }
  };
  const { isEvm } = useNetwork();
  const { provider } = useEthereum3();
  const { wallet } = useSolana3();
  const { connected } = useConnect2();
  const { updateParticleProvider, updateAccount, updateConnectId } = useConnectAction();
  const { setUnsupportedChain } = useUnsupportedChain();
  const { updateChain } = useChain();
  const { userChains } = useUserChains();
  useEffect4(() => {
    if (connectId === "particle" && connected) {
      const events = isEvm ? provider : wallet;
      const onDisconnect = () => {
        updateParticleProvider == null ? void 0 : updateParticleProvider(void 0);
        updateAccount == null ? void 0 : updateAccount("");
        updateConnectId == null ? void 0 : updateConnectId("");
        closeAllModal();
      };
      const onAccountsChanged = (accounts) => {
        if (accounts && accounts.length > 0) {
          updateAccount == null ? void 0 : updateAccount(accounts[0]);
        }
      };
      const onChainChanged = (id) => __async(this, null, function* () {
        const chainId = Number(id);
        const chain = chains.getEVMChainInfoById(chainId) || chains.getSolanaChainInfoById(chainId);
        updateChain == null ? void 0 : updateChain(chain);
        setUnsupportedChain == null ? void 0 : setUnsupportedChain(!chain || !userChains.find((x) => x.id === chain.id));
        const account2 = isEvm ? provider.selectedAddress : wallet.selectedAddress;
        updateAccount == null ? void 0 : updateAccount(account2);
        closeAllModal();
      });
      updateParticleProvider == null ? void 0 : updateParticleProvider(isEvm ? provider : wallet);
      const account = isEvm ? provider.selectedAddress : wallet.selectedAddress;
      updateAccount == null ? void 0 : updateAccount(account);
      updateChain == null ? void 0 : updateChain(
        isEvm ? chains.getEVMChainInfoById(Number(provider.chainId)) : chains.getSolanaChainInfoById(wallet.chainId)
      );
      events.on("disconnect", onDisconnect);
      events.on("accountsChanged", onAccountsChanged);
      events.on("chainChanged", onChainChanged);
      return () => {
        events.removeListener("disconnect", onDisconnect);
        events.removeListener("accountsChanged", onAccountsChanged);
        events.removeListener("chainChanged", onChainChanged);
      };
    }
    return () => {
    };
  }, [provider, connectId, connected, isEvm]);
  useEffect4(() => {
    setAuthKey("");
    if (open && walletMetas.length === 0) {
      initWallets();
    }
    if (open) {
      const htmlOverFlow = document.getElementsByTagName("html")[0].style.overflow;
      const bodyOverFlow = document.getElementsByTagName("body")[0].style.overflow;
      setOverflow([htmlOverFlow, bodyOverFlow]);
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("html")[0].style.overflow = overflow[0];
      document.getElementsByTagName("body")[0].style.overflow = overflow[1];
      setOverflow([]);
    }
  }, [open]);
  const modalCloseHandle = () => {
    setAuthKey("");
    setLoginStep("1");
    onClose && onClose();
  };
  const connectWallet = (preferredAuthType) => __async(this, null, function* () {
    try {
      yield connect({
        preferredAuthType,
        id: "particle"
      });
      modalCloseHandle();
    } catch (error) {
      if (preferredAuthType === "email" || preferredAuthType === "phone") {
        setAuthKey("");
        setLoginStep("1");
      }
    }
  });
  const groupItemClickHandle = useCallback4(
    (key, source) => {
      if (key) {
        setAuthKey(key);
        if (source === "particle") {
          const item = AuthGroup.find((item2) => item2.name === key) || {
            key: "",
            name: "",
            icon: void 0,
            methods: ""
          };
          setAuthItem(__spreadValues({}, item));
          connectWallet(item.key);
        } else {
          const item = walletMetas.find((item2) => item2.name === key);
          setAuthItem(__spreadValues({}, item));
          setMobileUri("");
          if ((item == null ? void 0 : item.methods) === "qrcode") {
            const id = item.key;
            try {
              const _connector = connectKit.getConnector(id);
              if (_connector) {
                let mobile = "";
                connectKit.once("connect", (provider2) => {
                  _connectSuccess(provider2, id);
                  modalCloseHandle();
                });
                const messageCall = (message) => __async(this, null, function* () {
                  var _a2, _b, _c, _d, _e, _f;
                  if ((message == null ? void 0 : message.type) === "connecting") {
                    if (((_a2 = _connector == null ? void 0 : _connector.mobile) == null ? void 0 : _a2.getUri) && isMobile()) {
                      mobile = yield _connector.mobile.getUri();
                      if (typeof window !== "undefined") {
                        window.localStorage.setItem(
                          "WALLETCONNECT_DEEPLINK_CHOICE",
                          JSON.stringify({
                            href: mobile.split("?")[0],
                            name: item.name
                          })
                        );
                      }
                    }
                    if (mobile && isMobile() && !(isIOS() && id === "walletconnect")) {
                      if (mobile.startsWith("http")) {
                        const link = document.createElement("a");
                        link.href = mobile;
                        link.target = "_blank";
                        link.rel = "noreferrer noopener";
                        link.click();
                      } else {
                        window.location.href = mobile;
                      }
                      return;
                    }
                    if (_connector && (_connector == null ? void 0 : _connector.qrCode) && ((_b = _connector == null ? void 0 : _connector.qrCode) == null ? void 0 : _b.getUri)) {
                      const uri = yield (_c = _connector == null ? void 0 : _connector.qrCode) == null ? void 0 : _c.getUri();
                      setMobileUri(uri);
                    } else {
                      setMobileUri("");
                    }
                  } else if ((message == null ? void 0 : message.type) === "display_uri") {
                    mobile = message.data;
                    if (isMobile() && ((_d = _connector.mobile) == null ? void 0 : _d.getAppLinkUri) && ((_e = _connector.mobile) == null ? void 0 : _e.getAppLinkUri())) {
                      mobile = `${(_f = _connector.mobile) == null ? void 0 : _f.getAppLinkUri()}?uri=${encodeURIComponent(
                        mobile
                      )}`;
                      window.localStorage.setItem(
                        "WALLETCONNECT_DEEPLINK_CHOICE",
                        JSON.stringify({
                          href: mobile.split("?")[0],
                          name: item.name
                        })
                      );
                    }
                    if (isMobile() && !(isIOS() && id === "walletconnect_v2")) {
                      if (mobile.startsWith("http")) {
                        const link = document.createElement("a");
                        link.href = mobile;
                        link.target = "_blank";
                        link.rel = "noreferrer noopener";
                        link.click();
                      } else {
                        window.location.href = mobile;
                      }
                    } else {
                      setMobileUri(mobile);
                    }
                  }
                });
                _connector.connector.off("message");
                _connector.connector.on("message", messageCall);
                try {
                  connectKit.connect(id).catch((error) => {
                    var _a2, _b, _c, _d;
                    setAuthItem(void 0);
                    setAuthKey("");
                    setMobileUri("");
                    setLoginStep("1");
                    if (error.message === "ConnectorNotFoundError: Connector not found") {
                      const url = isPhone ? (_b = (_a2 = item == null ? void 0 : item.data) == null ? void 0 : _a2.downloadUrls) == null ? void 0 : _b.qrCode : (_d = (_c = item == null ? void 0 : item.data) == null ? void 0 : _c.downloadUrls) == null ? void 0 : _d.browserExtension;
                      if (url) {
                        window.open(url);
                      }
                    }
                  });
                } catch (error) {
                  setMobileUri("");
                  throw new Error("connectKit.connect : error: " + JSON.stringify(error));
                }
              } else {
                setMobileUri("");
              }
            } catch (error) {
              setMobileUri("");
            }
          }
        }
      } else {
        setAuthItem(void 0);
        setAuthKey("");
      }
    },
    [authKey, walletMetas, connectKit]
  );
  const closeStep2 = () => {
    setLoginStep("1");
    setAuthKey("");
  };
  useEffect4(() => {
    if (authItem && (authItem == null ? void 0 : authItem.key) && (authItem == null ? void 0 : authItem.methods) && (authItem == null ? void 0 : authItem.methods) !== "browser") {
      setLoginStep("2");
    }
  }, [authItem, mobileUri]);
  const GroupChilderRender = (props) => {
    const { childKey, groups } = props;
    const source = childKey === "Particle Auth" ? "particle" : "wallet";
    const groupRender = groups.map(
      (item, idx) => childKey === "Particle Auth" ? isMoce || idx < 5 ? /* @__PURE__ */ React6.createElement(
        "div",
        {
          key: source + idx.toString(),
          onClick: () => groupItemClickHandle(item.name, source),
          className: `particle-connect-modal-group-item center-start ${!isPhone ? "particle-item-hover1" : ""} ${authKey === item.name ? "active" : ""}`
        },
        /* @__PURE__ */ React6.createElement("div", { className: "particle-group-icon-box" }, /* @__PURE__ */ React6.createElement("img", { src: item.icon, alt: "" })),
        t(`ConnectModal.${item.key}`)
      ) : null : /* @__PURE__ */ React6.createElement(
        "div",
        {
          key: source + idx.toString(),
          onClick: () => groupItemClickHandle(item.name, source),
          className: `particle-connect-modal-group-item center-start ${!isPhone ? "particle-item-hover1" : ""} ${authKey === item.name ? "active" : ""}`
        },
        /* @__PURE__ */ React6.createElement("div", { className: "particle-group-icon-box" }, /* @__PURE__ */ React6.createElement("img", { src: item.icon, alt: "" })),
        item.name
      )
    );
    return /* @__PURE__ */ React6.createElement("div", { key: source }, /* @__PURE__ */ React6.createElement("div", { className: "particle-connect-modal-group-name" }, childKey), groupRender, childKey === "Particle Auth" && particleAuthSort.length > 5 && walletMetas.length > 0 && /* @__PURE__ */ React6.createElement("div", { className: "particle-connect-more center-center", onClick: () => setIsMore(!isMoce) }, isMoce ? t("ConnectModal.less") : t("ConnectModal.more"), /* @__PURE__ */ React6.createElement("div", { className: `particle-icon_more ${isMoce ? "show" : "hide"}` })));
  };
  const getAuthWallet = () => {
    const arr = [];
    particleAuthSort.forEach((key) => {
      const obj = AuthGroup.find((item) => item.key === key);
      if (obj) {
        arr.push(obj);
      }
    });
    return arr;
  };
  const stopPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    return false;
  };
  return /* @__PURE__ */ React6.createElement(React6.Fragment, null, open ? /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(
    "div",
    {
      onTouchStart: stopPropagation,
      onScroll: stopPropagation,
      className: "particle-connect-modal-container center-center show"
    }
  ), /* @__PURE__ */ React6.createElement(
    "div",
    {
      className: "particle-connect-modal-box show",
      onTouchStart: stopPropagation,
      onScroll: stopPropagation
    },
    /* @__PURE__ */ React6.createElement("div", { className: "particle-connect-modal-close hover", onClick: modalCloseHandle }),
    /* @__PURE__ */ React6.createElement("div", { className: "particle-connect-modal-flex start-start" }, /* @__PURE__ */ React6.createElement(
      "div",
      {
        className: `flex1 particle-connect-methods-list ${loginStep === "1" ? "show" : "hide"}`
      },
      /* @__PURE__ */ React6.createElement("div", { className: "particle-connect-modal-title" }, t("ConnectModal.title2")),
      /* @__PURE__ */ React6.createElement("div", { className: "particle-connect-modal-gourp-list" }, (walletSort != null ? walletSort : []).length == 0 ? /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(
        GroupChilderRender,
        {
          childKey: "Particle Auth",
          groups: getAuthWallet()
        }
      ), walletMetas.length > 0 && /* @__PURE__ */ React6.createElement(
        GroupChilderRender,
        {
          childKey: "Wallet",
          groups: walletMetas
        }
      )) : /* @__PURE__ */ React6.createElement(React6.Fragment, null, (_a = walletSort == null ? void 0 : walletSort.filter((item) => {
        return item !== "Wallet" || walletMetas.length > 0;
      })) == null ? void 0 : _a.map((item, idx) => /* @__PURE__ */ React6.createElement(
        GroupChilderRender,
        {
          key: idx.toString(),
          childKey: item,
          groups: item === "Wallet" ? walletMetas : getAuthWallet()
        }
      ))))
    ), /* @__PURE__ */ React6.createElement("div", { className: `particle-connect-methods-form ${loginStep === "2" ? "show" : "hide"}` }, /* @__PURE__ */ React6.createElement("div", { className: "particle-icon-back", onClick: () => closeStep2() }), authKey ? /* @__PURE__ */ React6.createElement(
      ConnectForm_default,
      {
        authItem,
        mobileUri,
        onClose: modalCloseHandle
      }
    ) : /* @__PURE__ */ React6.createElement("div", { className: "center-center flex-column particle-no-auth-key" }, /* @__PURE__ */ React6.createElement("h3", null, t("ConnectModal.title1"), "?"), /* @__PURE__ */ React6.createElement("div", { className: "center-start particle-item-what" }, /* @__PURE__ */ React6.createElement("img", { className: "particle-icon-what", src: what_img1_default, alt: "" }), /* @__PURE__ */ React6.createElement("div", { className: "flex1" }, /* @__PURE__ */ React6.createElement("h5", null, t("ConnectModal.tip1")), /* @__PURE__ */ React6.createElement("p", null, t("ConnectModal.tip2")))), /* @__PURE__ */ React6.createElement("div", { className: "center-start particle-item-what" }, /* @__PURE__ */ React6.createElement("img", { className: "particle-icon-what", src: what_img2_default, alt: "" }), /* @__PURE__ */ React6.createElement("div", { className: "flex1" }, /* @__PURE__ */ React6.createElement("h5", null, t("ConnectModal.tip3")), /* @__PURE__ */ React6.createElement("p", null, t("ConnectModal.tip4")))))))
  )) : null);
}
var ConnectModal_default = ConnectModal;

// src/utils/common.ts
function getVersion() {
  return "web_1.3.3";
}

// src/provider/ModalContext.tsx
var ModalContext = createContext3({
  userChains: [],
  theme: "light",
  accountModalOpen: false,
  connectModalOpen: false,
  chainModalOpen: false,
  walletSort: ["Particle Auth", "Wallet"],
  unsupportedChain: false,
  language: "en",
  changLanguage: (val) => {
  },
  cacheProvider: true,
  options: {}
});
function useModalStateValue() {
  const [isModalOpen, setModalOpen] = useState5(false);
  return {
    closeModal: useCallback5(() => setModalOpen(false), []),
    isModalOpen,
    openModal: useCallback5(() => setModalOpen(true), [])
  };
}
function ModalProvider({
  children,
  options,
  theme: optionsTheme,
  walletSort = ["Particle Auth", "Wallet"],
  language: lang,
  cacheProvider = true
}) {
  const userChains = useMemo5(() => options.chains, [options]);
  const [theme, setTheme] = useState5(optionsTheme || "light");
  const [unsupportedChain, setUnsupportedChain] = useState5(false);
  const [account, setAccount] = useState5(void 0);
  const [chain, setChain] = useState5(void 0);
  const [particleProvider, setParticleProvider] = useState5(void 0);
  const [connectId, setConnectId] = useState5("");
  const [classTheme, setClassTheme] = useState5("");
  const [accountLoading, setAccountLoading] = useState5(true);
  const [language, setLanguage] = useState5(lang != null ? lang : "en");
  const { i18n: i18n2 } = useTranslation();
  const connectKit = useMemo5(() => {
    if (typeof window !== "undefined") {
      if (!window.particleConnect) {
        const kit = new ParticleConnect(options);
        kit.reactUIVersion = getVersion();
        window.particleConnect = kit;
      }
      return window.particleConnect;
    }
    return {};
  }, [options]);
  useEffect5(() => {
    if (i18n2)
      i18n2.changeLanguage(language);
  }, [language]);
  useEffect5(() => {
    switch (theme) {
      case "light":
        setClassTheme("particle-connect-ui-theme-ligth");
        break;
      case "dark":
        setClassTheme("particle-connect-ui-theme-dark");
        break;
      default:
        setClassTheme("particle-connect-ui-theme-ligth");
        break;
    }
  }, [theme]);
  const {
    closeModal: closeConnectModal,
    isModalOpen: connectModalOpen,
    openModal: openConnectModal
  } = useModalStateValue();
  const {
    closeModal: closeAccountModal,
    isModalOpen: accountModalOpen,
    openModal: openAccountModal
  } = useModalStateValue();
  const {
    closeModal: closeChainModal,
    isModalOpen: chainModalOpen,
    openModal: openChainModal
  } = useModalStateValue();
  const updateParticleProvider = useCallback5((provider) => setParticleProvider(provider), []);
  const updateAccount = useCallback5((account2) => setAccount(account2), []);
  const updateConnectId = useCallback5((id) => setConnectId(id), []);
  const updateChain = useCallback5((chain2) => setChain(chain2), []);
  const updateTheme = useCallback5((theme2) => setTheme(theme2), []);
  const updateLanguage = useCallback5((val) => setLanguage(val.replace("_", "-")), []);
  useEffect5(() => {
    if (!!(connectKit == null ? void 0 : connectKit.connect) && particleProvider) {
      const onDisconnect = () => {
        updateParticleProvider(void 0);
        updateAccount("");
        updateConnectId("");
        closeAccountModal();
        closeChainModal();
        closeConnectModal();
      };
      const onAccountsChanged = (accounts) => {
        if (accounts && accounts.length > 0) {
          updateAccount == null ? void 0 : updateAccount(accounts[0]);
        }
      };
      const onChainChanged = (chain2) => __async(this, null, function* () {
        setChain(chain2);
        setUnsupportedChain(!chain2 || !userChains.find((x) => x.id === chain2.id));
        const account2 = yield getPublicAddress2(particleProvider);
        updateAccount(account2);
        closeChainModal();
      });
      const onProviderChanged = (provider) => __async(this, null, function* () {
        setParticleProvider(provider);
        const account2 = yield getPublicAddress2(provider);
        updateAccount(account2);
      });
      connectKit.on("disconnect", onDisconnect);
      connectKit.on("accountsChanged", onAccountsChanged);
      connectKit.on("chainChanged", onChainChanged);
      connectKit.on("providerChanged", onProviderChanged);
      return () => {
        connectKit.removeListener("disconnect", onDisconnect);
        connectKit.removeListener("accountsChanged", onAccountsChanged);
        connectKit.removeListener("chainChanged", onChainChanged);
        connectKit.removeListener("providerChanged", onProviderChanged);
      };
    }
    return () => {
    };
  }, [connectKit, particleProvider]);
  return /* @__PURE__ */ React7.createElement(I18nProvider, null, /* @__PURE__ */ React7.createElement(AuthCoreContextProvider, { options: __spreadProps(__spreadValues({}, options), { themeType: theme, language }) }, /* @__PURE__ */ React7.createElement(
    ParticleKitChainProvider,
    {
      provider: particleProvider,
      chains: options.chains,
      chain,
      userChains,
      connectKit,
      connectId
    },
    /* @__PURE__ */ React7.createElement(
      ModalContext.Provider,
      {
        value: useMemo5(
          () => ({
            userChains,
            unsupportedChain,
            setUnsupportedChain,
            walletSort,
            accountLoading,
            connectKit,
            account,
            connectId,
            particleProvider,
            accountModalOpen,
            chainModalOpen,
            connectModalOpen,
            setAccountLoading,
            updateParticleProvider,
            updateConnectId,
            updateAccount,
            openAccountModal,
            openConnectModal,
            openChainModal,
            chain,
            updateChain,
            setTheme: updateTheme,
            closeAccountModal,
            theme,
            language,
            changLanguage: updateLanguage,
            cacheProvider,
            options
          }),
          [
            cacheProvider,
            unsupportedChain,
            setUnsupportedChain,
            closeAccountModal,
            walletSort,
            accountLoading,
            account,
            connectKit,
            particleProvider,
            accountModalOpen,
            connectModalOpen,
            connectId,
            chainModalOpen,
            setAccountLoading,
            updateParticleProvider,
            openAccountModal,
            openConnectModal,
            updateAccount,
            updateConnectId,
            openChainModal,
            openChainModal,
            chain,
            updateChain,
            userChains,
            updateTheme,
            theme,
            language,
            updateLanguage,
            options
          ]
        )
      },
      /* @__PURE__ */ React7.createElement("div", { className: "particle-connect-ui " + classTheme }, children, /* @__PURE__ */ React7.createElement("div", { className: "connect-body" }, /* @__PURE__ */ React7.createElement(
        ConnectModal_default,
        {
          onClose: closeConnectModal,
          open: connectModalOpen,
          closeAllModal: () => {
            closeAccountModal();
            closeChainModal();
            closeConnectModal();
          }
        }
      ), /* @__PURE__ */ React7.createElement(
        ChainModal_default,
        {
          chains: options.chains,
          onClose: closeChainModal,
          open: chainModalOpen
        }
      )))
    )
  )));
}
function useParticleTheme() {
  const { theme, setTheme } = useContext3(ModalContext);
  return {
    theme,
    setTheme
  };
}
function useLanguage() {
  const { language, changLanguage } = useContext3(ModalContext);
  return {
    language,
    changLanguage
  };
}
function useConnectKit() {
  const { connectKit } = useContext3(ModalContext);
  return connectKit;
}
var useChain = () => {
  const { updateChain } = useContext3(ModalContext);
  return { updateChain };
};
var useUnsupportedChain = () => {
  const { setUnsupportedChain, unsupportedChain } = useContext3(ModalContext);
  return { setUnsupportedChain, unsupportedChain };
};
function useConnectAction() {
  const { updateParticleProvider, updateAccount, updateConnectId } = useContext3(ModalContext);
  return {
    updateParticleProvider,
    updateAccount,
    updateConnectId
  };
}
function useIsCacheProvider() {
  const { cacheProvider } = useContext3(ModalContext);
  return cacheProvider;
}
function useModalState() {
  const { accountModalOpen, connectModalOpen, chainModalOpen } = useContext3(ModalContext);
  return {
    accountModalOpen,
    chainModalOpen,
    connectModalOpen
  };
}
function useUserChains() {
  const { userChains } = useContext3(ModalContext);
  return { userChains };
}
function useAccountModal() {
  const { openAccountModal, closeAccountModal } = useContext3(ModalContext);
  return { openAccountModal, closeAccountModal };
}
function useConnectModal() {
  const { openConnectModal } = useContext3(ModalContext);
  return { openConnectModal };
}
function useChainModal() {
  const { openChainModal } = useContext3(ModalContext);
  return { openChainModal };
}
function useAccountInfo() {
  const { account, particleProvider, connectId, accountLoading, setAccountLoading } = useContext3(ModalContext);
  return {
    account,
    connectId,
    particleProvider,
    accountLoading,
    setAccountLoading
  };
}
function useWalletSort() {
  const { walletSort } = useContext3(ModalContext);
  return { walletSort };
}
var useParticleAuthTypes = () => {
  const { options } = useContext3(ModalContext);
  const particleAuthSort = useMemo5(() => {
    if (options.authTypes && options.authTypes.length > 0) {
      return options.authTypes.filter((item) => item !== AuthType2.jwt);
    }
    return Object.values(AuthType2).filter((item) => item !== AuthType2.jwt);
  }, [options.authTypes]);
  return particleAuthSort;
};

// src/hooks/useAccount.ts
function useAccount() {
  const { account } = useAccountInfo();
  return account;
}

// src/hooks/useConnectId.ts
function useConnectId() {
  const { connectId } = useAccountInfo();
  return connectId;
}

// src/hooks/useParticleProvider.ts
function useParticleProvider() {
  const { particleProvider } = useAccountInfo();
  if (particleProvider) {
    return particleProvider;
  }
  return void 0;
}

// src/services/AuthAvatar.tsx
import React8, { useState as useState6, useEffect as useEffect6 } from "react";

// src/services/blockies.js
var randseed = new Array(4);
function seedrand(seed) {
  for (var i = 0; i < randseed.length; i++) {
    randseed[i] = 0;
  }
  for (var i = 0; i < seed.length; i++) {
    randseed[i % 4] = (randseed[i % 4] << 5) - randseed[i % 4] + seed.charCodeAt(i);
  }
}
function rand() {
  var t = randseed[0] ^ randseed[0] << 11;
  randseed[0] = randseed[1];
  randseed[1] = randseed[2];
  randseed[2] = randseed[3];
  randseed[3] = randseed[3] ^ randseed[3] >> 19 ^ t ^ t >> 8;
  return (randseed[3] >>> 0) / (1 << 31 >>> 0);
}
function createColor() {
  var h = Math.floor(rand() * 360);
  var s = rand() * 60 + 40 + "%";
  var l = (rand() + rand() + rand() + rand()) * 25 + "%";
  var color = "hsl(" + h + "," + s + "," + l + ")";
  return color;
}
function createImageData(size) {
  var width = size;
  var height = size;
  var dataWidth = Math.ceil(width / 2);
  var mirrorWidth = width - dataWidth;
  var data = [];
  for (var y = 0; y < height; y++) {
    var row = [];
    for (var x = 0; x < dataWidth; x++) {
      row[x] = Math.floor(rand() * 2.3);
    }
    var r = row.slice(0, mirrorWidth);
    r.reverse();
    row = row.concat(r);
    for (var i = 0; i < row.length; i++) {
      data.push(row[i]);
    }
  }
  return data;
}
function buildOpts(opts) {
  var newOpts = {};
  newOpts.seed = opts.seed || Math.floor(Math.random() * Math.pow(10, 16)).toString(16);
  seedrand(newOpts.seed);
  newOpts.size = opts.size || 8;
  newOpts.scale = opts.scale || 4;
  newOpts.color = opts.color || createColor();
  newOpts.bgcolor = opts.bgcolor || createColor();
  newOpts.spotcolor = opts.spotcolor || createColor();
  return newOpts;
}
function renderIcon(opts, canvas) {
  opts = buildOpts(opts || {});
  var imageData = createImageData(opts.size);
  var width = Math.sqrt(imageData.length);
  canvas.width = canvas.height = opts.size * opts.scale;
  var cc = canvas.getContext("2d");
  cc.fillStyle = opts.bgcolor;
  cc.fillRect(0, 0, canvas.width, canvas.height);
  cc.fillStyle = opts.color;
  for (var i = 0; i < imageData.length; i++) {
    if (imageData[i]) {
      var row = Math.floor(i / width);
      var col = i % width;
      cc.fillStyle = imageData[i] === 1 ? opts.color : opts.spotcolor;
      cc.fillRect(col * opts.scale, row * opts.scale, opts.scale, opts.scale);
    }
  }
  return canvas;
}
function createIcon(opts, canvas) {
  renderIcon(opts, canvas);
  return canvas;
}

// src/services/AuthAvatar.tsx
function BlockiesIdenticon(props) {
  var _a, _b;
  const pri_canvas = document.createElement("canvas");
  const [canvas] = useState6(pri_canvas);
  const [wallImg, setWallImg] = useState6("");
  const size = (((_a = props == null ? void 0 : props.opts) == null ? void 0 : _a.size) || 10) * (((_b = props == null ? void 0 : props.opts) == null ? void 0 : _b.scale) || 8);
  function getOpts() {
    var _a2, _b2, _c, _d, _e, _f;
    return {
      seed: ((_a2 = props == null ? void 0 : props.opts) == null ? void 0 : _a2.seed) || "foo",
      color: ((_b2 = props == null ? void 0 : props.opts) == null ? void 0 : _b2.color) || "#dfe",
      bgcolor: ((_c = props == null ? void 0 : props.opts) == null ? void 0 : _c.bgcolor) || "#a71",
      size: ((_d = props == null ? void 0 : props.opts) == null ? void 0 : _d.size) || 15,
      scale: ((_e = props == null ? void 0 : props.opts) == null ? void 0 : _e.scale) || 3,
      spotcolor: ((_f = props == null ? void 0 : props.opts) == null ? void 0 : _f.spotcolor) || "#000"
    };
  }
  useEffect6(() => {
    const img = createIcon(getOpts(), canvas).toDataURL();
    setWallImg(img);
  }, [props, canvas]);
  return /* @__PURE__ */ React8.createElement(
    "div",
    {
      style: {
        height: size,
        width: size,
        backgroundImage: `url(${wallImg})`,
        backgroundSize: "100% auto",
        backgroundRepeat: "no-repeat"
      }
    }
  );
}
var AuthAvatar_default = BlockiesIdenticon;

// src/utils/string.ts
var shortString = (longValue) => {
  if (!longValue) {
    return "";
  }
  if (longValue.length <= 10) {
    return longValue;
  }
  return `${longValue.slice(0, 5)}...${longValue.slice(longValue.length - 5, longValue.length)}`;
};

// src/components/AccountModal/index.tsx
import { tronAddressFromHex } from "@particle-network/auth-core";
import { useAuthCore } from "@particle-network/auth-core-modal";
import React9, { memo as memo2, useCallback as useCallback6, useEffect as useEffect7, useState as useState7 } from "react";
import { ReactSVG } from "react-svg";

// src/assets/images/buy_svg.svg
var buy_svg_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9J2N1cnJlbnRDb2xvcicgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIHN0cm9rZTogIzcwNzA3MDsKICAgICAgICBvcGFjaXR5OiAwOwogICAgICB9CgogICAgICAuY2xzLTIgewogICAgICAgIGZpbGw6IGN1cnJlbnRDb2xvcjsKICAgICAgfQoKICAgICAgLmNscy0zIHsKICAgICAgICBzdHJva2U6IG5vbmU7CiAgICAgIH0KCiAgICAgIC5jbHMtNCB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9Iue7hF8xNDA0IiBkYXRhLW5hbWU9Iue7hCAxNDA0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYxOS44MyAtMjA4LjUpIj4KICAgIDxnIGlkPSLnn6nlvaJfNjA0IiBkYXRhLW5hbWU9IuefqeW9oiA2MDQiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYxOS44MyAyMDguNSkiPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTQiIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTkiIGhlaWdodD0iMTkiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJGaWxsXzU1MiIgZGF0YS1uYW1lPSJGaWxsIDU1MiIgY2xhc3M9ImNscy0yIiBkPSJNMTcuMzU5LDE0LjYzOUgyLjNhMi4zLDIuMywwLDAsMS0yLjMtMi4zVjIuM0EyLjMsMi4zLDAsMCwxLDIuMywwSDE3LjM1OWEyLjMsMi4zLDAsMCwxLDIuMywyLjNWMTIuMzM5QTIuMywyLjMsMCwwLDEsMTcuMzU5LDE0LjYzOVpNMS4yNTUsNC42djcuNzM4QTEuMDQ3LDEuMDQ3LDAsMCwwLDIuMywxMy4zODVIMTcuMzU5QTEuMDQ3LDEuMDQ3LDAsMCwwLDE4LjQsMTIuMzM5VjQuNlpNMi4zLDEuMjU1QTEuMDQ3LDEuMDQ3LDAsMCwwLDEuMjU1LDIuM1YzLjM0NkgxOC40VjIuM2ExLjA0NywxLjA0NywwLDAsMC0xLjA0NS0xLjA0NlpNOC45OTMsMTEuMjk0SDMuOTc0YS42MjguNjI4LDAsMSwxLDAtMS4yNTVIOC45OTNhLjYyOC42MjgsMCwxLDEsMCwxLjI1NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2MjAgMjExLjE4MikiLz4KICA8L2c+Cjwvc3ZnPgo=";

// src/assets/images/close_svg.svg
var close_svg_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9J2N1cnJlbnRDb2xvcicgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHZpZXdCb3g9IjAgMCAxOC4yNDMgMTguMjQzIj4KICA8ZyBpZD0i57uEXzEzMTYiIGRhdGEtbmFtZT0i57uEIDEzMTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuMTIxIDIuMTIxKSI+CiAgICA8bGluZSBpZD0i55u057q/XzQ2IiBkYXRhLW5hbWU9IuebtOe6vyA0NiIgeDI9IjE0IiB5Mj0iMTQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMyIvPgogICAgPGxpbmUgaWQ9IuebtOe6v181OCIgZGF0YS1uYW1lPSLnm7Tnur8gNTgiIHgxPSIxNCIgeTI9IjE0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiLz4KICA8L2c+Cjwvc3ZnPgo=";

// src/assets/images/copy_svg.svg
var copy_svg_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9J2N1cnJlbnRDb2xvcicgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIHN0cm9rZTogIzcwNzA3MDsKICAgICAgICBvcGFjaXR5OiAwOwogICAgICB9CgogICAgICAuY2xzLTIgewogICAgICAgIGZpbGw6IGN1cnJlbnRDb2xvcjsKICAgICAgfQoKICAgICAgLmNscy0zIHsKICAgICAgICBzdHJva2U6IG5vbmU7CiAgICAgIH0KCiAgICAgIC5jbHMtNCB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9Iue7hF8xNDA1IiBkYXRhLW5hbWU9Iue7hCAxNDA1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYxOS44MyAtMjU0LjUpIj4KICAgIDxnIGlkPSLnn6nlvaJfNjA1IiBkYXRhLW5hbWU9IuefqeW9oiA2MDUiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYxOS44MyAyNTQuNSkiPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTMiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIvPgogICAgICA8cmVjdCBjbGFzcz0iY2xzLTQiIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTkiIGhlaWdodD0iMTkiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJGaWxsXzU3NyIgZGF0YS1uYW1lPSJGaWxsIDU3NyIgY2xhc3M9ImNscy0yIiBkPSJNMTUuNjg1LDBoLTkuMmEyLjMsMi4zLDAsMCwwLTIuMywyLjNWNC4xODNIMi4zQTIuMywyLjMsMCwwLDAsMCw2LjQ4M3Y5LjJhMi4zLDIuMywwLDAsMCwyLjMsMi4zaDkuMmEyLjMsMi4zLDAsMCwwLDIuMy0yLjNWMTMuOGgxLjg4MmEyLjMsMi4zLDAsMCwwLDIuMy0yLjNWMi4zQTIuMywyLjMsMCwwLDAsMTUuNjg1LDBaTTUuNDM3LDQuMTgzVjIuM0ExLjA0NywxLjA0NywwLDAsMSw2LjQ4MywxLjI1NWg5LjJBMS4wNDcsMS4wNDcsMCwwLDEsMTYuNzMxLDIuM3Y5LjJhMS4wNDcsMS4wNDcsMCwwLDEtMS4wNDYsMS4wNDZIMTMuOFY2LjQ4M2EyLjMsMi4zLDAsMCwwLTIuMy0yLjNaTTIuMywxNi43MzFhMS4wNDcsMS4wNDcsMCwwLDEtMS4wNDYtMS4wNDZ2LTkuMkExLjA0NywxLjA0NywwLDAsMSwyLjMsNS40MzdoOS4yYTEuMDQ3LDEuMDQ3LDAsMCwxLDEuMDQ2LDEuMDQ2djkuMkExLjA0NywxLjA0NywwLDAsMSwxMS41LDE2LjczMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2MjAuODM3IDI1NS41MDgpIi8+CiAgPC9nPgo8L3N2Zz4K";

// src/assets/images/logout_svg.svg
var logout_svg_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiBjdXJyZW50Q29sb3I7CiAgICAgICAgc3Ryb2tlOiAjNzA3MDcwOwogICAgICAgIG9wYWNpdHk6IDA7CiAgICAgIH0KCiAgICAgIC5jbHMtMi1sb2cgewogICAgICAgIGZpbGw6ICNmOTI1MzE7CiAgICAgIH0KCiAgICAgIC5jbHMtMyB7CiAgICAgICAgc3Ryb2tlOiBub25lOwogICAgICB9CgogICAgICAuY2xzLTQgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSLnu4RfMTQwNiIgZGF0YS1uYW1lPSLnu4QgMTQwNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2MTkuNDEgLTI5OC41KSI+CiAgICA8ZyBpZD0i55+p5b2iXzYwNiIgZGF0YS1uYW1lPSLnn6nlvaIgNjA2IiBjbGFzcz0iY2xzLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2MTkuNDEgMjk4LjUpIj4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy00IiB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE5IiBoZWlnaHQ9IjE5Ii8+CiAgICA8L2c+CiAgICA8cGF0aCBpZD0iRmlsbF81OTgiIGRhdGEtbmFtZT0iRmlsbCA1OTgiIGNsYXNzPSJjbHMtMi1sb2ciIGQ9Ik0xMy4xNzYsMTguODJIMi4zQTIuMywyLjMsMCwwLDEsMCwxNi41MnYtOS4yYTIuMywyLjMsMCwwLDEsMi4zLTIuM0gzLjk3NGEuNjI4LjYyOCwwLDAsMSwwLDEuMjU1SDIuM0ExLjA0NywxLjA0NywwLDAsMCwxLjI1NSw3LjMxOHY5LjJBMS4wNDcsMS4wNDcsMCwwLDAsMi4zLDE3LjU2NkgxMy4xNzZhMS4wNDcsMS4wNDcsMCwwLDAsMS4wNDYtMS4wNDZ2LTkuMmExLjA0NywxLjA0NywwLDAsMC0xLjA0Ni0xLjA0NkgxMS41YS42MjguNjI4LDAsMSwxLDAtMS4yNTVoMS42NzNhMi4zLDIuMywwLDAsMSwyLjMsMi4zdjkuMkEyLjMsMi4zLDAsMCwxLDEzLjE3NiwxOC44MlpNNy43MzgsMTEuMjkxYS42MjguNjI4LDAsMCwxLS42MjgtLjYyN1YyLjEzOUw1LjY3MiwzLjU3OGEuNjMxLjYzMSwwLDAsMS0uODg2LDAsLjYyNi42MjYsMCwwLDEsMC0uODg3TDcuMjk1LjE4MmEuNjMyLjYzMiwwLDAsMSwuODg3LDBsMi41MDksMi41MDlhLjYyNi42MjYsMCwwLDEsMCwuODg3LjYzMi42MzIsMCwwLDEtLjg4NywwTDguMzY1LDIuMTM5djguNTI0QS42MjguNjI4LDAsMCwxLDcuNzM4LDExLjI5MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2MzguODIgMzAwLjc2Mikgcm90YXRlKDkwKSIvPgogIDwvZz4KPC9zdmc+Cg==";

// src/assets/images/wallet_svg.svg
var wallet_svg_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICBmaWxsPSdjdXJyZW50Q29sb3InIHdpZHRoPSIxZW0iIGhlaWdodD0iMWVtIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IGN1cnJlbnRDb2xvcjsKICAgICAgICBzdHJva2U6ICM3MDcwNzA7CiAgICAgICAgb3BhY2l0eTogMDsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiBjdXJyZW50Q29sb3I7CiAgICAgIH0KCiAgICAgIC5jbHMtMyB7CiAgICAgICAgc3Ryb2tlOiBub25lOwogICAgICB9CgogICAgICAuY2xzLTQgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSLnu4RfMTQwMyIgZGF0YS1uYW1lPSLnu4QgMTQwMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2MTkuNSAtMTY2KSI+CiAgICA8ZyBpZD0i55+p5b2iXzYwMyIgZGF0YS1uYW1lPSLnn6nlvaIgNjAzIiBjbGFzcz0iY2xzLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2MTkuNSAxNjYpIj4KICAgICAgPHJlY3QgY2xhc3M9ImNscy0zIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiLz4KICAgICAgPHJlY3QgY2xhc3M9ImNscy00IiB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE5IiBoZWlnaHQ9IjE5Ii8+CiAgICA8L2c+CiAgICA8cGF0aCBpZD0iRmlsbF81NTQiIGRhdGEtbmFtZT0iRmlsbCA1NTQiIGNsYXNzPSJjbHMtMiIgZD0iTTE1LjY4NSwxNy45MDVIMi4zQTIuMywyLjMsMCwwLDEsMCwxNS42VjUuMTgxQTIuMywyLjMsMCwwLDEsMS43MTUsMi45NTdMMTIuNTkuMDc4QTIuMjk0LDIuMjk0LDAsMCwxLDE1LjQ3NywyLjN2Ljk2NGguMjA5YTIuMywyLjMsMCwwLDEsMi4zLDIuM1YxNS42QTIuMywyLjMsMCwwLDEsMTUuNjg1LDE3LjkwNVpNMi4zLDQuNTJBMS4wNDcsMS4wNDcsMCwwLDAsMS4yNTUsNS41NjZWMTUuNkExLjA0NywxLjA0NywwLDAsMCwyLjMsMTYuNjUxSDE1LjY4NUExLjA0NywxLjA0NywwLDAsMCwxNi43MzEsMTUuNlYxMi44ODZIMTQuMDEyYTIuMywyLjMsMCwwLDEsMC00LjZoMi43MTlWNS41NjZBMS4wNDcsMS4wNDcsMCwwLDAsMTUuNjg1LDQuNTJaTTE0LjAxMiw5LjU0YTEuMDQ2LDEuMDQ2LDAsMSwwLDAsMi4wOTJoMi43MTlWOS41NFptLS44MzUtOC4yODRhMS4wNDcsMS4wNDcsMCwwLDAtLjI2OS4wMzZMNS40NDYsMy4yNjZoOC43NzZWMi4zYTEuMDQ4LDEuMDQ4LDAsMCwwLTEuMDQ0LTEuMDQ2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYyMC40MTcgMTY3KSIvPgogIDwvZz4KPC9zdmc+Cg==";

// src/components/AccountModal/index.tsx
function AccountModal({ open, onClose, mode }) {
  const account = useAccount();
  const { t } = useTranslation();
  const modalCloseHandle = () => {
    onClose && onClose();
  };
  const [accountName, setAccountName] = useState7(account);
  const [copiedAddress, setCopiedAddress] = useState7(false);
  const connectId = useConnectId();
  const chain = useCurrentChain();
  const { disconnect } = useParticleConnect();
  const [overflow, setOverflow] = useState7([]);
  useEffect7(() => {
    if (open) {
      const htmlOverFlow = document.getElementsByTagName("html")[0].style.overflow;
      const bodyOverFlow = document.getElementsByTagName("body")[0].style.overflow;
      setOverflow([htmlOverFlow, bodyOverFlow]);
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("html")[0].style.overflow = overflow[0];
      document.getElementsByTagName("body")[0].style.overflow = overflow[1];
      setOverflow([]);
    }
  }, [open]);
  const stopPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    return false;
  };
  useEffect7(() => {
    var _a;
    if (account && ((_a = chain == null ? void 0 : chain.name) == null ? void 0 : _a.toLowerCase()) === "tron") {
      setAccountName(shortString(tronAddressFromHex(account)));
    } else {
      setAccountName(shortString(account));
    }
  }, [account, chain]);
  const copyAddressAction = useCallback6(() => {
    if (account) {
      navigator.clipboard.writeText(account);
      setCopiedAddress(true);
      setTimeout(() => {
        setCopiedAddress(false);
      }, 1e3);
    }
  }, [account]);
  const logout = useCallback6(() => __async(this, null, function* () {
    try {
      yield disconnect();
    } catch (error) {
    }
    onClose && onClose();
  }), []);
  const { openWallet, openBuy } = useAuthCore();
  const toWallet = () => {
    openWallet();
    modalCloseHandle();
  };
  const toBuy = () => {
    openBuy();
    modalCloseHandle();
  };
  return /* @__PURE__ */ React9.createElement(React9.Fragment, null, open ? /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(
    "div",
    {
      className: "particle-account-modal-container center-center show ",
      onClick: modalCloseHandle,
      onTouchStart: stopPropagation,
      onScroll: stopPropagation
    }
  ), /* @__PURE__ */ React9.createElement(
    "div",
    {
      className: `particle-account-modal-box  center-start flex-column  show ${mode || "bottomRight"}`,
      onScroll: stopPropagation
    },
    /* @__PURE__ */ React9.createElement("div", { className: "particle-account-header" }, /* @__PURE__ */ React9.createElement("div", { className: "particle-avatar" }, /* @__PURE__ */ React9.createElement(AuthAvatar_default, { opts: { seed: account, size: 33, scale: 1 } })), /* @__PURE__ */ React9.createElement("span", { className: "particle-account-address" }, accountName), /* @__PURE__ */ React9.createElement(
      ReactSVG,
      {
        src: close_svg_default,
        className: "particle-account-modal-close hover",
        onClick: modalCloseHandle
      }
    )),
    connectId === "particle" && /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement("div", { className: "particle-link-item", onClick: toWallet }, /* @__PURE__ */ React9.createElement(ReactSVG, { src: wallet_svg_default, className: "icon" }), t("AccountModal.wallet")), /* @__PURE__ */ React9.createElement("div", { className: "particle-link-item", onClick: toBuy }, /* @__PURE__ */ React9.createElement(ReactSVG, { src: buy_svg_default, className: "icon" }), t("AccountModal.buy"))),
    /* @__PURE__ */ React9.createElement("div", { className: "particle-link-item", onClick: copyAddressAction }, /* @__PURE__ */ React9.createElement(ReactSVG, { src: copy_svg_default, className: "icon" }), copiedAddress ? /* @__PURE__ */ React9.createElement(React9.Fragment, null, t("AccountModal.copied"), "!") : t("AccountModal.copy_address")),
    /* @__PURE__ */ React9.createElement("div", { className: "particle-link-item red", onClick: logout }, /* @__PURE__ */ React9.createElement(ReactSVG, { src: logout_svg_default, className: "icon" }), t("AccountModal.logout"))
  )) : void 0);
}
var AccountModal_default = memo2(AccountModal);

// src/components/ConnectButton/ConnectButtonRenderer.tsx
import { tronAddressFromHex as tronAddressFromHex2 } from "@particle-network/auth-core";
import React10, { useEffect as useEffect8, useState as useState8 } from "react";
var noop = () => {
};
function ConnectButtonRenderer({ children }) {
  const account = useAccount();
  const [isCustomButton, setIsCustonButton] = useState8(false);
  const { cacheconnect } = useParticleConnect();
  const { openConnectModal } = useConnectModal();
  const { openAccountModal, closeAccountModal } = useAccountModal();
  const { openChainModal } = useChainModal();
  const { accountModalOpen, connectModalOpen } = useModalState();
  const { accountLoading } = useAccountInfo();
  const { chain } = useNetwork();
  const accountFilter = (ant) => {
    if (!ant)
      return "";
    let account2 = ant;
    if ((chain == null ? void 0 : chain.name.toLowerCase()) === "tron") {
      account2 = tronAddressFromHex2(ant);
    }
    return shortString(account2);
  };
  useEffect8(() => {
    cacheconnect();
  }, []);
  const openAccount = () => {
    setIsCustonButton(true);
    openAccountModal == null ? void 0 : openAccountModal();
  };
  const closeAccount = () => {
    setIsCustonButton(false);
    closeAccountModal == null ? void 0 : closeAccountModal();
  };
  return /* @__PURE__ */ React10.createElement("div", { className: `custom-btn-box ${isCustomButton ? "account-show" : ""}` }, children({
    chain,
    account,
    accountStr: accountFilter(account),
    accountModalOpen,
    connectModalOpen,
    openChainModal: openChainModal != null ? openChainModal : noop,
    openAccountModal: openAccount != null ? openAccount : noop,
    closeAccountModal: closeAccount != null ? closeAccount : noop,
    openConnectModal: openConnectModal != null ? openConnectModal : noop,
    accountLoading
  }), /* @__PURE__ */ React10.createElement(AccountModal_default, { onClose: closeAccount, open: accountModalOpen }));
}
ConnectButtonRenderer.displayName = "ConnectButton.Custom";

// src/components/ConnectButton/index.tsx
function ConnectButton({ modalMode }) {
  const [isUIButton, setIsUIbutton] = useState9(false);
  const { cacheconnect } = useParticleConnect();
  const account = useAccount();
  const { openConnectModal } = useConnectModal();
  const { openAccountModal, closeAccountModal } = useAccountModal();
  const { openChainModal } = useChainModal();
  const { accountModalOpen } = useModalState();
  const chain = useCurrentChain();
  const { accountLoading } = useAccountInfo();
  const { unsupportedChain } = useUnsupportedChain();
  const { t } = useTranslation();
  const openAccount = () => {
    setIsUIbutton(true);
    openAccountModal == null ? void 0 : openAccountModal();
  };
  const closeAccount = () => {
    setIsUIbutton(false);
    closeAccountModal == null ? void 0 : closeAccountModal();
  };
  useEffect9(() => {
    cacheconnect();
  }, []);
  const accountFilter = (ant) => {
    if (!ant)
      return "";
    let account2 = ant;
    if ((chain == null ? void 0 : chain.name.toLowerCase()) === "tron") {
      account2 = tronAddressFromHex3(ant);
    }
    return shortString(account2);
  };
  if (accountLoading) {
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null);
  }
  if (unsupportedChain) {
    return /* @__PURE__ */ React11.createElement("div", { className: "particle-unsupported-chain-button  center-center", onClick: openChainModal }, /* @__PURE__ */ React11.createElement("span", null, " ", t("ConnectButton.wrongNetwork")), " ", /* @__PURE__ */ React11.createElement("div", { className: "particle-icon-more" }));
  }
  const getChainDisplayName = (chainInfo) => {
    if (!chainInfo) {
      return "";
    }
    if (chainInfo.network === "Mainnet") {
      return chainInfo.fullname.replace(" Mainnet", "");
    } else {
      return chainInfo.fullname;
    }
  };
  if (accountLoading) {
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null);
  }
  if (unsupportedChain) {
    return /* @__PURE__ */ React11.createElement("div", { className: "particle-unsupported-chain-button  center-center", onClick: openChainModal }, /* @__PURE__ */ React11.createElement("span", null, " ", t("ConnectButton.wrongNetwork")), " ", /* @__PURE__ */ React11.createElement("div", { className: "particle-icon-more" }));
  }
  return /* @__PURE__ */ React11.createElement("div", { className: `center-center particle-user-bar-container connect-body ${isUIButton ? "is-ui-button" : ""}` }, account ? /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement("div", { className: "particle-account-info center-center particle-chain", onClick: openChainModal }, /* @__PURE__ */ React11.createElement("div", { className: "particle-avatar-img", style: { backgroundImage: `url(${chain == null ? void 0 : chain.icon})` } }), /* @__PURE__ */ React11.createElement("span", null, getChainDisplayName(chain)), /* @__PURE__ */ React11.createElement("div", { className: "particle-icon-more" })), /* @__PURE__ */ React11.createElement("div", { className: "particle-account-info-fixed" }, /* @__PURE__ */ React11.createElement(
    "div",
    {
      className: "particle-account-info center-center",
      onClick: () => accountModalOpen ? closeAccount == null ? void 0 : closeAccount() : openAccount == null ? void 0 : openAccount()
    },
    /* @__PURE__ */ React11.createElement("div", { className: "particle-avatar-img" }, /* @__PURE__ */ React11.createElement(AuthAvatar_default, { opts: { seed: account, size: 24, scale: 1 } })),
    /* @__PURE__ */ React11.createElement("span", null, accountFilter(account)),
    /* @__PURE__ */ React11.createElement("div", { className: "particle-icon-more" })
  ), /* @__PURE__ */ React11.createElement(AccountModal_default, { onClose: closeAccount, open: accountModalOpen, mode: modalMode }))) : /* @__PURE__ */ React11.createElement("div", { className: "particle-connect-wallet-btn", onClick: openConnectModal }, t("ConnectButton.connectWallet")));
}
var ConnectButton_default = ConnectButton;
ConnectButton.Custom = ConnectButtonRenderer;
export {
  ConnectButton_default as ConnectButton,
  ModalProvider,
  useAccount,
  useAccountInfo,
  useConnectId,
  useConnectKit,
  useConnectModal,
  useLanguage,
  useModalState,
  useNetwork,
  useParticleConnect,
  useParticleProvider,
  useParticleTheme,
  useSwitchChains,
  useWalletMetas
};
//# sourceMappingURL=index.js.map
